<template>
    <Dialog class="p-dialog-maximized sheet-dialog" v-model:visible="isVisible" :draggable="false" :closable="false" @show="setKeyPressDetection">
        <template #header>
            <div class="row col-md-12">
                <div class="row mb-3 col-md-12">
                    <div class="col-md-8">
                        <div>
							<span class="p-dialog-title" v-if="companyReportSheets.length > 0">
								{{ name }} + {{ balanceSheetDate }} + {{ currencyCode }}'000 + {{ purpose }}
							</span>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="d-flex justify-content-end" style="align-items: center;">
                            <div class="col-md-12">
                                <div class="col-md-12 d-flex justify-content-end">
                                    <TheLoading v-if="isLoading && !saveDialog.visible"></TheLoading>
                                    
                                    <Button v-if="type == 'rpk'" icon="pi pi-bars" rounded @click="toggleShortcutMenu($event)" :disabled="isLoading || isPageLoading"/>
                                    <Menu v-if="type == 'rpk'" ref="shortcutMenu" :model="shortcutMenuItems" :popup="true"/>

                                    <span class="p-1"></span>
                                    <Button ref="navigatePrev" class="p-button-sm" icon="pi pi-chevron-left" @click="onNavigatePrev" aria-label="Previous Page" :disabled="isLoading || isPageLoading" />
                                    <span class="p-1"></span>
                                    <Dropdown ref="sheetDialogDropdown" id="p-dropdown-header-sheet" class="p-dropdown-header-sheet" v-model="navigateValue" filter :options="companyReportSheets" :optionLabel="type == 'cwk' ? 'sheet.index' : 'sheet_code'" 
                                        placeholder="Select a Sheet" @change="onNavigateChange(false, null)" :disabled="isLoading || isPageLoading" :autoOptionFocus="true" :filterFields="['sheet_code', 'sheet_name', 'sheet_sequence']" :resetFilterOnHide="true"
                                        style="width: 280px" :pt="{ panel: { class: 'p-dropdown-panel-auto' } }">
                                        <template #value="dropdownProps">
                                            <div v-if="dropdownProps.value" class="row flex align-items-center">
                                                <span v-if="type == 'rpk'" class="col-md-3">{{ dropdownProps.value.sheet_code }}</span>
                                                <span v-if="type == 'cwk'" class="col-md-3">{{ dropdownProps.value.sheet_sequence }}</span>
                                                <span v-if="type == 'rpk'" class="col-md-9">[{{ dropdownProps.value.sheet_sequence }}] {{ dropdownProps.value.sheet_name }}</span>
                                                <span v-if="type == 'cwk'" class="col-md-9">{{ dropdownProps.value.sheet_name }}</span>
                                            </div>

                                            <span v-else>
												{{ dropdownProps.placeholder }}
											</span>
                                        </template>

                                        <template #option="dropdownProps">
                                            <div class="row">
                                                <span v-if="type == 'rpk'" class="col-md-3">{{ dropdownProps.option.sheet_code }}</span>
                                                <span v-if="type == 'cwk'" class="col-md-3">{{ dropdownProps.option.sheet_sequence }}</span>
                                                <span v-if="type == 'rpk'" class="col-md-9">[{{ dropdownProps.option.sheet_sequence }}] {{ dropdownProps.option.sheet_name }}</span>
                                                <span v-if="type == 'cwk'" class="col-md-9">{{ dropdownProps.option.sheet_name }}</span>
                                            </div>
                                        </template>
                                    </Dropdown>
                                    <span class="p-1"></span>
                                    <Button ref="navigateNext" class="p-button-sm" icon="pi pi-chevron-right" @click="onNavigateNext" aria-label="Next Page" :disabled="isLoading || isPageLoading" />
                                    <span class="p-1"></span>
                                    <Button class="p-button-sm" @click="save(isNearestThousandPreview)" label="Save" :disabled="isLoading || isPageLoading || !isEditable" :hidden="isViewer" />
                                    <Button class="p-dialog-header-icons" icon="pi pi-times" severity="secondary" text rounded @click="cancel" aria-label="Cancel" :disabled="isLoading || isPageLoading" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row col-md-12">
                    <div class="col-md-8">
                        <h6 v-if="companyReportSheets.length > 0 && !isPageLoading">
                            <span>{{ companyReportSheets[sheetIndex].sheet_code }} - {{ companyReportSheets[sheetIndex].sheet_name }}</span>
                            <span v-if="companyReportSheets[sheetIndex].sheet_sequence != null"> (Sheet {{ companyReportSheets[sheetIndex].sheet_sequence }})</span>
                            <span class="text-danger"> ID: {{ id.toFixed(2) }}</span>
                        </h6>
                        <h6 v-else>
                            <span class="p-1"></span>
                        </h6>
                    </div>

                    <div class="col-md-4">
                        <div class="d-flex justify-content-end" style="align-items: center;">
                            <div class="me-2 col-md-6">
                                <Slider class="zoom-slider" v-model="zoomLevel" :min="0.5" :max="1.5" :step="0.1" :disabled="isLoading || isPageLoading" />
                            </div>
                            <Button class="p-button-sm p-button-zoom" icon="pi pi-minus" :disabled="isLoading ||  isPageLoading || zoomLevel == 0.5" @click="zoomOut" />
                            <span class="p-1"></span>
                            <Button class="p-button-sm p-button-zoom" icon="pi pi-plus" :disabled="isLoading || isPageLoading || zoomLevel == 1.5" @click="zoomIn" />
                            <span class="p-1"></span>
                            <Button class="p-button-sm p-button-zoom" icon="pi pi-refresh" :disabled="isLoading || isPageLoading" @click="resetZoom" />
                            <Button id="btnShortcutTips" class="p-button-sm p-button-warning p-button-zoom" icon="pi pi-question" style="position:absolute; right:1.5rem" @mouseover="toggleTips" @mouseout="toggleTips" />
                            <OverlayPanel ref="shortcutTips" class="shortcut-tips">
                                <div class="row">
                                    <div class="col-md-12">F1: Open/Close Help Tips</div>
                                    <div class="col-md-12">F2: Zoom Out</div>
                                    <div class="col-md-12">F3: Zoom In</div>
                                    <div class="col-md-12">F4: Reset Zoom</div>
                                    <div class="col-md-12">F6: Select Sheet</div>
                                    <div class="col-md-12">F7: Previous Sheet</div>
                                    <div class="col-md-12">F8: Next Sheet</div>
                                    <div class="col-md-12">F9: Go To Linked Cell</div>
                                    <div class="col-md-12">F10: Back</div>
                                    <div class="col-md-12">ESC: Clear Input Field</div>
                                    <!-- <div class="col-md-12">Up: Next Row</div>
									<div class="col-md-12">Down: Previous Row</div> -->
                                </div>
                            </OverlayPanel>
                        </div>
                    </div>
                </div>

                <div class="row col-md-12">
                    <div class="col-md-12 d-flex justify-content-end">
                        <span class="fw-bold" style="position:absolute;">{{ componentHeader }}</span>
                        <span class="p-1"></span>
                    </div>
                </div>
            </div>
        </template>

        <div class="m-0">
            <TheTabViewLoading v-if="isPageLoading"></TheTabViewLoading>

            <div :class="'zoom-template-' + parseInt(zoomLevel * 100)" v-if="!isPageLoading">
                <div v-if="pageError == ''">
                    <div class="p-template-stick-header">
                        <div class="m-auto d-flex align-items-center justify-content-center position-relative" :style="{'width': tableWidth + (companyReportSheets[sheetIndex].template == null ? 0 : (companyReportSheets[sheetIndex].template[0].columns.length * (parseInt(zoomLevel * 10) - 10))) + 'rem'}" v-if="companyReportSheets[sheetIndex].sheetError == ''">
                            <DataTable class="p-datatable-template p-datatable-template-header-only" :value="[]" showGridlines tableClass="editable-cells-table" :style="{'width': tableWidth + (companyReportSheets[sheetIndex].template[0].columns.length * (parseInt(zoomLevel * 10) - 10)) + 'rem'}">
                                <Column field="" header="" class="p-template-column-number">
                                    <template #body="slotProps">
                                        <div class="d-flex">
                                            <span class="p-row-title-text">{{ slotProps.index + 1 }}</span>
                                        </div>
                                    </template>
                                </Column>

                                <Column v-for="{header, columnIndex} in visibleColumnHeaders" :key="columnIndex" :field="header" :header="header" :style="{'width': (columnIndex != 0 ? 9 : firstColumnWidth) + parseInt(zoomLevel * 10) - 10 + 'rem', 'max-width': (columnIndex != 0 ? 9 : firstColumnWidth) + parseInt(zoomLevel * 10) - 10 + 'rem'}">
                                    <template #header>
                                        <div class="p-column-title-text-header">
                                            <span class="p-column-title-text">{{ header }}</span>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <div :class="{'d-flex' : isHorizontalScrollbar}" :style="{'width': !isHorizontalScrollbar ? 'auto' : (tableWidth + (companyReportSheets[sheetIndex].template == null ? 0 : (companyReportSheets[sheetIndex].template[0].columns.length * (parseInt(zoomLevel * 10) - 10))) + 'rem')}">
                        <div style="width:max-content; position:sticky; left:0; z-index:99" v-if="isHorizontalScrollbar">
                            <DataTable class="p-datatable-template p-datatable-template-body-only" :value="companyReportSheets[sheetIndex].template" showGridlines tableClass="editable-cells-table">
                                <Column field="index" header="" class="p-template-column-number">
                                    <template #body="slotProps">
                                        <div :ref="el => registerIndexColumnCellRef(el, slotProps.index)" class="d-flex" :class="getBorder(slotProps.index)">
                                            <span class="p-row-title-text">{{ slotProps.index + 1 }}</span>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>

                        <div class="d-flex justify-content-center" v-for="(companyReportSheet,index) in companyReportSheets" :key="companyReportSheet.identifier">
                            <div v-if="index == sheetIndex">
                                <div class="d-flex">
                                    <div class="m-0" v-if="companyReportSheet.sheetError == ''">
                                        <DataTable :ref="el => registerMainTableRef(el)" class="p-datatable-template p-datatable-template-body-only" :value="companyReportSheet.template" showGridlines tableClass="editable-cells-table" :style="{'width': tableWidth - (isHorizontalScrollbar ? 4 : 0) + (companyReportSheet.template[0].columns.length * (parseInt(zoomLevel * 10) - 10)) + 'rem'}">
                                            <Column field="" header="" class="p-template-column-number" v-if="!isHorizontalScrollbar">
                                                <template #body="slotProps">
                                                    <div class="d-flex">
                                                        <span class="p-row-title-text">{{ slotProps.index + 1 }}</span>
                                                    </div>
                                                </template>
                                            </Column>

                                            <Column v-for="{header, columnIndex} of visibleColumnHeaders" :key="columnIndex" :field="header" :header="header" class="p-template-column-cell" :style="{'width': (columnIndex != 0 ? 9 : firstColumnWidth) + parseInt(zoomLevel * 10) - 10 + 'rem', 'max-width': (columnIndex != 0 ? 9 : firstColumnWidth) + parseInt(zoomLevel * 10) - 10 + 'rem', 'padding': '0px'}"
                                                    :pt="{
													bodycell: ({ parent, props }) => ({
														colspan: getCellColspan(parent.props.rowIndex, columnIndex),
														style: getCellDisplay(parent.props.rowIndex, columnIndex),
													})
												}"
                                            >
                                                <template #header>
                                                    <span class="p-column-title-text">{{ header }}</span>
                                                </template>

                                                <template #body="slotProps">
                                                    <div :style="(slotProps.data.columns[columnIndex] == null ? null : slotProps.data.columns[columnIndex].style)" :class="sheetIndex + '_' + header + (slotProps.index + 1)" class="row col-md-12 p-cell-body" :title="(slotProps.data.columns[columnIndex] != null && slotProps.data.columns[columnIndex].component != null && (slotProps.data.columns[columnIndex].component == 'FORMULA' || slotProps.data.columns[columnIndex].component == 'NAVIGATE' || slotProps.data.columns[columnIndex].component == 'VALUE')) ? slotProps.data.columns[columnIndex].value: ''" v-tooltip.bottom="slotProps.data.columns[columnIndex] == null ? '' : getCommentValue(slotProps.data.columns[columnIndex].comment)">
                                                        <div v-if="slotProps.data.columns[columnIndex] != null && slotProps.data.columns[columnIndex].component != null && (slotProps.data.columns[columnIndex].component == 'LONGLABEL' || slotProps.data.columns[columnIndex].component == 'LABEL' || slotProps.data.columns[columnIndex].component == 'HEADER')" class="p-cell-body-component" style="width: calc(100%);">
                                                            <div v-if="slotProps.data.columns != null && slotProps.data.columns[columnIndex] != null && slotProps.data.columns[columnIndex].component != null">
                                                                <div v-if="slotProps.data.columns[columnIndex].component == 'LABEL' || slotProps.data.columns[columnIndex].component == 'HEADER'">
                                                                    <label :class="(columnIndex + 1) < slotProps.data.columns.length && (slotProps.data.columns[columnIndex + 1] == null || slotProps.data.columns[columnIndex + 1].component == null) ? 'w-max' : ''">{{ slotProps.data.columns[columnIndex].value }}</label>
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'LONGLABEL'">
                                                                    <label>{{ slotProps.data.columns[columnIndex].value }}</label>
                                                                </div>
                                                            </div>

                                                            <div v-else-if="slotProps.data.columns[columnIndex] != null">
                                                                <InputText v-model="slotProps.data.columns[columnIndex].value" style="visibility: hidden;" />
                                                            </div>
                                                        </div>

                                                        <div class="p-cell-body-component" style="width: calc(100% - 1.7rem);" v-else-if="slotProps.data.columns[columnIndex] != null && slotProps.data.columns[columnIndex].component != null && slotProps.data.columns[columnIndex].component == 'VALUE'">
                                                            <div v-if="slotProps.data.columns != null && slotProps.data.columns[columnIndex] != null && slotProps.data.columns[columnIndex].component != null">
                                                                <div>
                                                                    <InputText 
                                                                    :modelValue="slotProps.data.columns[columnIndex].actualValue" 
                                                                    :placeholder="slotProps.data.columns[columnIndex].value" 
                                                                    :readonly="true" 
                                                                    class="p-cell-body-component-enabled p-sheet-component-input" 
                                                                    @focusin="inputFocus(slotProps.index, columnIndex)" 
                                                                    v-if="slotProps.data.columns[columnIndex].actualValue != null && isNaN(slotProps.data.columns[columnIndex].actualValue)" 
                                                                    @keydown="onArrowKeysPress($event, slotProps.index, columnIndex)" />
                                                                    <InputNumber v-number 
                                                                        :class="{'p-cell-body-component-disabled  p-sheet-component-input': true  ,'p-invalid': slotProps.data.columns[columnIndex].invalid}" 
                                                                        :minFractionDigits="getFractionDigitsFromSettings(slotProps.data.columns[columnIndex].settings)"
                                                                        :maxFractionDigits="getFractionDigitsFromSettings(slotProps.data.columns[columnIndex].settings) ?? 10"
                                                                        :modelValue="getPercentageDisplayValue(slotProps.data.columns[columnIndex])"
                                                                        :readonly="true"
                                                                        :suffix="slotProps.data.columns[columnIndex].settings?.isPercentage ? '%' : null"
                                                                        @focusin="inputFocus(slotProps.index, columnIndex)" 
                                                                        @keydown="onArrowKeysPress($event, slotProps.index, columnIndex)" 
                                                                        v-else 
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="p-cell-body-component" style="width: calc(100% - 1.7rem);" v-else>
                                                            <div v-if="slotProps.data.columns != null && slotProps.data.columns[columnIndex] != null && slotProps.data.columns[columnIndex].component != null">
                                                                <div v-if="slotProps.data.columns[columnIndex].component == 'FORMULA' && (slotProps.data.columns[columnIndex].isChild || !slotProps.data.columns[columnIndex].isChild && companyReportSheet.template[slotProps.index].columns[0].component != 'COMPANY')">
                                                                    <label class="w-max" v-if="columnIndex == 0">{{ slotProps.data.columns[columnIndex].actualValue }}</label>
                                                                    <label
                                                                    class="text-danger" :class="'w-' + getLabelMaxWidth(slotProps.index, columnIndex)" v-else-if="(slotProps.data.columns[columnIndex].value != null && slotProps.data.columns[columnIndex].value.startsWith('=IF(')) || (slotProps.data.columns[columnIndex].actualValue != null && isNaN(slotProps.data.columns[columnIndex].actualValue))">
                                                                    {{ slotProps.data.columns[columnIndex].actualValue }}
                                                                    </label>
                                                                    <!-- <InputText v-model="slotProps.data.columns[columnIndex].actualValue" :placeholder="slotProps.data.columns[columnIndex].value" :readonly="true" class="{'p-cell-body-component-disabled p-sheet-component-input': true  ,'p-invalid': slotProps.data.columns[columnIndex].invalid}" @focusin="inputFocus(slotProps.index, columnIndex)" v-else-if="slotProps.data.columns[columnIndex].actualValue != null && isNaN(slotProps.data.columns[columnIndex].actualValue)" @keydown="onArrowKeysPress($event, slotProps.index, columnIndex)" /> -->
                                                                    <InputNumber
                                                                    v-number
                                                                    :class="{'p-cell-body-component-disabled p-sheet-component-input': true  ,'p-invalid': slotProps.data.columns[columnIndex].invalid}"
                                                                    :minFractionDigits="getFractionDigitsFromSettings(slotProps.data.columns[columnIndex].settings)"
                                                                    :maxFractionDigits="getFractionDigitsFromSettings(slotProps.data.columns[columnIndex].settings) ?? 2"
                                                                    :modelValue="getPercentageDisplayValue(slotProps.data.columns[columnIndex])"
                                                                    :readonly="true"
                                                                    :suffix="slotProps.data.columns[columnIndex].settings?.isPercentage ? '%' : null"
                                                                    @focusin="inputFocus(slotProps.index, columnIndex)"
                                                                    @keydown="onArrowKeysPress($event, slotProps.index, columnIndex)"
                                                                    v-else />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'DATETIME'">
                                                                    <!-- <InputText v-model="slotProps.data.columns[columnIndex].actualValue" :readonly="true" class="p-cell-body-component-enabled p-sheet-component-input" /> -->
                                                                    <label v-if="slotProps.data.columns[columnIndex].value == null">{{ slotProps.data.columns[columnIndex].actualValue }}</label>
                                                                    <Calendar
                                                                    dateFormat="dd/mm/yy"
                                                                    :modelValue="slotProps.data.columns[columnIndex].actualValue ? parse(slotProps.data.columns[columnIndex].actualValue, 'dd/MM/yyyy', new Date()) : null"
                                                                    @update:modelValue="value => {
                                                                        slotProps.data.columns[columnIndex].actualValue = formatDateObject(value);
                                                                        changeTextValue(slotProps.index, columnIndex, true);
                                                                    }"
                                                                    :disabled="!isEditable"
                                                                    class="p-cell-body-component-enabled p-sheet-component-input text-right"
                                                                    v-else/>
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'NAVIGATE'">
                                                                    <InputText v-model="slotProps.data.columns[columnIndex].actualValue" :placeholder="slotProps.data.columns[columnIndex].value" :readonly="true" class="p-cell-body-component-enabled p-sheet-component-input" @focusin="inputFocus(slotProps.index, columnIndex)" v-if="slotProps.data.columns[columnIndex].actualValue != null && isNaN(slotProps.data.columns[columnIndex].actualValue)" @keydown="onArrowKeysPress($event, slotProps.index, columnIndex)" />
                                                                    <InputNumber v-number v-model="slotProps.data.columns[columnIndex].actualValue" :readonly="true" class="p-cell-body-component-disabled p-sheet-component-input" @focusin="inputFocus(slotProps.index, columnIndex)" @keydown="onArrowKeysPress($event, slotProps.index, columnIndex)" :maxFractionDigits="10" v-else />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'NUMBER' && (slotProps.data.columns[columnIndex].isChild || !slotProps.data.columns[columnIndex].isChild && companyReportSheet.template[slotProps.index].columns[0].component != 'COMPANY')">
                                                                    <InputNumber
                                                                        v-number
                                                                        :modelValue="getPercentageDisplayValue(slotProps.data.columns[columnIndex])"
                                                                        :readonly="!isEditable"
                                                                        :disabled="isDisableCompanyInputRow(slotProps.index)"
                                                                        class="p-cell-body-component-enabled p-sheet-component-input"
                                                                        :minFractionDigits="getFractionDigitsFromSettings(slotProps.data.columns[columnIndex].settings)"
                                                                        :maxFractionDigits="getFractionDigitsFromSettings(slotProps.data.columns[columnIndex].settings) ?? 10"
                                                                        :suffix="slotProps.data.columns[columnIndex].settings?.isPercentage ? '%' : null"
                                                                        @update:modelValue="(input: any) => {
                                                                            const newActualValue = getPercentageStoredValue(slotProps.data.columns[columnIndex], input);
                                                                            // Only propagate / autoSave when the underlying value actually changed.
                                                                            // PrimeVue's InputNumber re-emits update:modelValue on focus when its formatter
                                                                            // re-normalizes the display, which previously caused every focus on a gray cell
                                                                            // to write to memcache. Compare against the current actualValue (treating null
                                                                            // and 0 as equivalent so an empty cell focused without typing isn't forced to 0).
                                                                            const oldActualValue = slotProps.data.columns[columnIndex].actualValue;
                                                                            const oldNorm = (oldActualValue === null || oldActualValue === undefined || oldActualValue === '') ? 0 : Number(oldActualValue);
                                                                            const newNorm = (newActualValue === null || newActualValue === undefined || newActualValue === '') ? 0 : Number(newActualValue);
                                                                            if (oldNorm === newNorm) {
                                                                                return;
                                                                            }
                                                                            slotProps.data.columns[columnIndex].actualValue = newActualValue;
                                                                            changeNumberValue(slotProps.index, columnIndex, true);
                                                                            autoSave(sheetIndex);
                                                                        }"
                                                                        @focusin="inputFocus(slotProps.index, columnIndex); highlightInput($event)"
                                                                        :step="0"
                                                                        @keydown="onArrowKeysPress($event, slotProps.index, columnIndex)"
                                                                    />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'TEXT' || slotProps.data.columns[columnIndex].component == 'HEADERTEXT'">
                                                                    <InputText :modelValue="slotProps.data.columns[columnIndex].actualValue" :placeholder="slotProps.data.columns[columnIndex].value" :readonly="!isEditable" class="p-cell-body-component-enabled p-sheet-component-input" @focusin="inputFocus(slotProps.index, columnIndex); highlightInput($event)" @keydown="onArrowKeysPress($event, slotProps.index, columnIndex)" @update:modelValue="(input: any) => {
                                                                        const oldText = slotProps.data.columns[columnIndex].actualValue;
                                                                        const oldNorm = (oldText === null || oldText === undefined) ? '' : String(oldText);
                                                                        const newNorm = (input === null || input === undefined) ? '' : String(input);
                                                                        if (oldNorm === newNorm) {
                                                                            return;
                                                                        }
                                                                        slotProps.data.columns[columnIndex].actualValue = input;
                                                                        changeTextValue(slotProps.index, columnIndex, true);
                                                                        autoSave(sheetIndex);
                                                                    }" />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'LONGTEXT'">
                                                                    <InputText v-model="slotProps.data.columns[columnIndex].actualValue" :placeholder="slotProps.data.columns[columnIndex].value" :readonly="!isEditable" class="p-cell-body-component-enabled p-sheet-component-input" @focusin="inputFocus(slotProps.index, columnIndex); highlightInput($event)" @keydown="onArrowKeysPress($event, slotProps.index, columnIndex)" />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'COMPANY'">
                                                                    <div class="row col-md-12" v-if="slotProps.data.columns[columnIndex].isChild">
                                                                        <div class="col-md-6" v-tooltip.top="{value: showCompanyTooltip(slotProps.data.columns[columnIndex].actualValue.debit), disabled: slotProps.data.columns[columnIndex].actualValue.debit == null}">
                                                                            <Dropdown :options="showDebitCompanies(slotProps.index)" optionLabel="name" filter showClear placeholder="- Credit -" v-model="slotProps.data.columns[columnIndex].actualValue.debit" :disabled="!isEditable || isDisableCompany(slotProps.index)" :id="'zoom-template-' + parseInt(zoomLevel * 100) + '-company-debit'" class="p-cell-body-component-enabled p-sheet-component-input p-cell-body-component-company-debit">
                                                                                    <template #value="company">
                                                                                    <div v-if="company.value">
                                                                                        {{ company.value.name }}
                                                                                    </div>
                                                                                    <div v-else>
                                                                                        {{ company.placeholder }}
                                                                                    </div>
                                                                                </template>
                                                                                <!-- <template #option="company">
                                                                                    <div v-if="!checkDebitCompanyExist(slotProps.index, company)">
                                                                                        <span>{{ company.option.name }}</span>
                                                                                    </div>

                                                                                    <span v-else class="company-option-pair"></span>
                                                                                </template> -->
                                                                            </Dropdown>
                                                                        </div>

                                                                        <div class="col-md-6" v-tooltip.top="{value: showCompanyTooltip(slotProps.data.columns[columnIndex].actualValue.credit), disabled: slotProps.data.columns[columnIndex].actualValue.credit == null}">
                                                                            <Dropdown :options="showCreditCompanies(slotProps.index)" optionLabel="name" filter showClear placeholder="- Debit -" v-model="slotProps.data.columns[columnIndex].actualValue.credit" :disabled="!isEditable || isDisableCompany(slotProps.index)" :id="'zoom-template-' + parseInt(zoomLevel * 100) + '-company-credit'" class="p-cell-body-component-enabled p-sheet-component-input p-cell-body-component-company-credit">
                                                                                <template #value="company">
                                                                                    <div v-if="company.value">
                                                                                        {{ company.value.name }}
                                                                                    </div>
                                                                                    <div v-else>
                                                                                        {{ company.placeholder }}
                                                                                    </div>
                                                                                </template>
                                                                                <!-- <template #option="company">
                                                                                    <div v-if="!checkCreditCompanyExist(slotProps.index, company)">
                                                                                        <span>{{ company.option.name }}</span>
                                                                                    </div>

                                                                                    <span v-else class="company-option-pair"></span>
                                                                                </template> -->
                                                                            </Dropdown>
                                                                        </div>
                                                                    </div>

                                                                    <label v-else>Inter-Company</label>
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'COMPANYDROPDOWN'">
                                                                    <div class="col-md-12" v-tooltip.top="{value: showCompanyTooltip(slotProps.data.columns[columnIndex].actualValue), disabled: slotProps.data.columns[columnIndex].actualValue == null}">
                                                                        <Dropdown :options="companyDropdownCompanies" optionLabel="name" filter :filterFields="['code', 'name']" showClear placeholder="- Company -" v-model="slotProps.data.columns[columnIndex].actualValue" 
                                                                            class="p-cell-body-component-enabled p-sheet-component-input p-dropdown-header-company" :disabled="!isEditable || isDisableNonCompany(slotProps.index, slotProps.data.columns[columnIndex].component, 'up') || isDisableNonCompany(slotProps.index, slotProps.data.columns[columnIndex].component, 'down')"
                                                                            style="width: 130px" :pt="{ panel: { class: 'p-dropdown-panel-auto' } }">
                                                                            <template #value="company">
                                                                                <div v-if="company.value">
                                                                                    {{ company.value.name }}
                                                                                </div>
                                                                                <div v-else>
                                                                                    {{ company.placeholder }}
                                                                                </div>
                                                                            </template>
                                                                            <template #option="company">
                                                                                <div v-if="!checkNonCompanyExist(slotProps.index, company, slotProps.data.columns[columnIndex].component)" class="d-flex align-items-center">
                                                                                    <!-- <span class="col-md-3">{{ company.option.code }}</span>
                                                                                    <span class="col-md-9">{{ company.option.name }}</span> -->
                                                                                    <span>{{ company.option.code }} | {{ company.option.name }}</span>
                                                                                </div>

                                                                                <span v-else class="companydropdown-option-pair"></span>
                                                                            </template>
                                                                        </Dropdown>
                                                                    </div>
                                                                </div>
                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'COUNTRY'">
                                                                    <Dropdown :options="countries" optionLabel="code" filter :filterFields="['code', 'name']" showClear placeholder="- Country -" v-model="slotProps.data.columns[columnIndex].actualValue" class="p-cell-body-component-enabled p-sheet-component-input p-cell-body-component-country" :disabled="!isEditable || isDisableNonCompany(slotProps.index, slotProps.data.columns[columnIndex].component, 'up') || isDisableNonCompany(slotProps.index, slotProps.data.columns[columnIndex].component, 'down')">
                                                                        <template #option="country">
                                                                            <div v-if="!checkNonCompanyExist(slotProps.index, country, slotProps.data.columns[columnIndex].component)" class="d-flex align-items-center">
                                                                                <!-- <span class="col-md-3">{{ country.option.code }}</span>
                                                                                <span class="col-md-9">{{ country.option.name }}</span> -->
                                                                                <span>{{ country.option.code }} | {{ country.option.name }}</span>
                                                                            </div>

                                                                            <span v-else class="country-option-pair"></span>
                                                                        </template>
                                                                    </Dropdown>
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex].component == 'CURRENCY'">
                                                                    <Dropdown :options="currencies" optionLabel="code" filter :filterFields="['code', 'name']" showClear placeholder="- Currency -" v-model="slotProps.data.columns[columnIndex].actualValue" class="p-cell-body-component-enabled p-sheet-component-input p-cell-body-component-currency" :disabled="!isEditable || isDisableNonCompany(slotProps.index, slotProps.data.columns[columnIndex].component, 'up') || isDisableNonCompany(slotProps.index, slotProps.data.columns[columnIndex].component, 'down')">
                                                                        <template #option="currency">
                                                                            <div v-if="!checkNonCompanyExist(slotProps.index, currency, slotProps.data.columns[columnIndex].component)" class="d-flex align-items-center">
                                                                                <!-- <span class="col-md-3">{{ currency.option.code }}</span>
                                                                                <span class="col-md-9">{{ currency.option.name }}</span> -->
                                                                                <span>{{ currency.option.code }} | {{ currency.option.name }}</span>
                                                                            </div>

                                                                            <span v-else class="currency-option-pair"></span>
                                                                        </template>
                                                                    </Dropdown>
                                                                </div>
                                                            </div>

                                                            <div v-else-if="slotProps.data.columns[columnIndex] != null">
                                                                <InputText v-model="slotProps.data.columns[columnIndex].value" style="visibility: hidden;" />
                                                            </div>
                                                        </div>

                                                        <div v-if="slotProps.data.columns[columnIndex] != null && slotProps.data.columns[columnIndex].component != null && slotProps.data.columns[columnIndex].component != 'LONGLABEL' && slotProps.data.columns[columnIndex].component != 'LABEL'" class="p-cell-body-menu" style="width: 1.5rem;">
                                                            <div>
                                                                <div v-if="slotProps.data.columns[columnIndex] != null && slotProps.data.columns[columnIndex].component != null && (slotProps.data.columns[columnIndex].component == 'NAVIGATE'|| slotProps.data.columns[columnIndex].component == 'FORMULA') && slotProps.data.columns[columnIndex].value != null && slotProps.data.columns[columnIndex].value.includes('!')">
                                                                    <Button icon="pi pi-chevron-right" class="p-button-success p-button-cell-collapsible" @click="navigateCellComponent(slotProps.index, columnIndex)" />
                                                                </div>

                                                                <div v-else-if="slotProps.data.columns[columnIndex] != null && slotProps.data.columns[columnIndex].component != null && (slotProps.data.columns[columnIndex].component == 'NUMBER' || slotProps.data.columns[columnIndex].component == 'TEXT' || slotProps.data.columns[columnIndex].component == 'COMPANYDROPDOWN' || slotProps.data.columns[columnIndex].component == 'COUNTRY' || slotProps.data.columns[columnIndex].component == 'CURRENCY') && (slotProps.data.columns[columnIndex].isChild || !slotProps.data.columns[columnIndex].isChild && companyReportSheet.template[slotProps.index].columns[0].component != 'COMPANY')">
                                                                    <div v-if="hasComment(slotProps.data.columns[columnIndex].comment)" class="p-cell-body-component-comment"></div>
                                                                    <Button icon="pi pi-chevron-down" class="p-button-primary p-button-cell-collapsible" @click="toggleComment(slotProps.index, columnIndex)" />
                                                                </div>

                                                                <div v-if="isEditable && slotProps.data.columns[columnIndex] != null && slotProps.data.columns[columnIndex].component != null && slotProps.data.columns[columnIndex].component == 'COMPANY' && !slotProps.data.columns[columnIndex].isChild">
                                                                    <Button icon="pi pi-plus" class="p-button-primary p-button-cell-collapsible" @click="insertCompany(slotProps.index)" />
                                                                </div>

                                                                <div v-if="isEditable && slotProps.data.columns[columnIndex] != null && slotProps.data.columns[columnIndex].component != null && slotProps.data.columns[columnIndex].component == 'COMPANY' && slotProps.data.columns[columnIndex].isChild">
                                                                    <Button icon="pi pi-minus" class="p-button-danger p-button-cell-collapsible" @click="removeCompany(slotProps.index)" :disabled="isDisableCompany(slotProps.index)" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </Column>
                                        </DataTable>
                                    </div>

                                    <div class="m-0" v-if="companyReportSheet.sheetError != ''">
                                        <div class="align-items-center justify-content-center error-content">
                                            <div class="error">
                                                <FontAwesomeIcon style="color: var(--bs-danger);" :icon="['fas', 'triangle-exclamation']" size="2x" />

                                                <div>
                                                    <h6><span>{{ companyReportSheet.sheetError }}</span></h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
                </div>
            </div>
        </div>
    </Dialog>

    <Dialog header="Comment" v-model:visible="commentDialog.visible" :draggable="false" :style="{ width: '50vw' }" @hide="closeComment()">
        <div class="row">
            <div class="col-md-12 p-4">
                <div class="row mb-3">
                    <div class="col-md-12">
                        <Textarea v-model="commentDialog.comment" :autoResize="false" rows="5" cols="30" maxlength="255" placeholder="Comment" autofocus :disabled="!isEditable" />
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 d-flex justify-content-start">
                <Button class="p-button-sm p-button-warning" label="Remove Comments" @click="removeComment" :disabled="commentDialog.comment == null" />
            </div>

            <div class="col-md-6 d-flex justify-content-end">
                <Button class="p-button-text p-button-sm" label="Cancel" @click="closeComment()" />
                <span class="p-1"></span>
                <Button class="p-button-sm" label="Save" @click="saveComment" :disabled="v$.commentDialog.$invalid" />
            </div>
        </div>
    </Dialog>

    <Dialog header="Save Changes" v-model:visible="saveDialog.visible" :draggable="false" modal :style="{ width: '40vw' }" @hide="closeSave()">
        <p>
            Detected changes are made and did not save. Would you like to save the changes?
        </p>

        <template #footer>
            <div class="col-md-12 d-flex justify-content-end">
                <TheLoading v-if="isLoading && saveDialog.visible"></TheLoading>
                <span class="p-1"></span>
                <Button label="Discard" icon="pi pi-times" @click="discardChanges()" text />
                <span class="p-1"></span>
                <Button label="Save" icon="pi pi-check" @click="saveChanges()" />
            </div>
        </template>
    </Dialog>

    <Dialog header="Intercompany Order Correction" v-model:visible="intercompanyDialog.visible" :draggable="false" modal :closable="false" :style="{ width: '40vw' }">
        <p>
            Detected intercompany debit &amp; credit companies in reverse order in the following sheet(s):
            <b>{{ intercompanyDialog.sheetCodes.join(', ') }}</b>.
        </p>
        <p>
            Would you like to auto-correct the order by switching debit and credit? The change will not be saved until you perform a Save action.
        </p>

        <template #footer>
            <div class="col-md-12 d-flex justify-content-end">
                <Button label="No" icon="pi pi-times" @click="declineIntercompanyCorrection()" text />
                <span class="p-1"></span>
                <Button label="Yes, Correct" icon="pi pi-check" @click="applyIntercompanyCorrection()" />
            </div>
        </template>
    </Dialog>
</template>

<script lang="ts">
    import { defineComponent, ref, computed, nextTick } from "vue";
    import store from "@/store";
    import sheetApi from "@/api/sheet-api";
    import templateApi from "@/api/template-api";
    import companyReportApi from "@/api/companyreport-api";
    import companyReportSheetApi from "@/api/companyreportsheet-api";
    import companyReportSheetTemplateApi from "@/api/companyreportsheettemplate-api";
    import companyApi from "@/api/company-api";
    import countryApi from "@/api/country-api";
    import currencyApi from "@/api/currency-api";
    import eliminationSettingApi from "@/api/eliminationsetting-api";
    import roleMixin from "@/mixin/role";
    import formulaMixin from "@/mixin/formula";
    import dateUtilsMixin from "@/mixin/utils/date-utils";

    import TheTabViewLoading from "@/components/TheTabViewLoading.vue";
    import TheLoading from "@/components/TheLoading.vue";
    import ThePageError from "@/components/ThePageError.vue";

    import useVuelidate from "@vuelidate/core";
    import { required, requiredIf } from "@vuelidate/validators";

    import { format } from 'date-fns';
    import { parse } from 'date-fns';

    import * as tokens from 'excel-formula-tokenizer';

    export default defineComponent({
        mixins: [roleMixin, formulaMixin, dateUtilsMixin],
        emits: ['save', 'saveButtonClicked', 'autoSave', 'cancel', 'deleteCached'],
        expose: ['refreshDropdown', 'refreshInterCompanyDropdown'],
        directives: {
            // enables v-focus in template
            focus
        },
        components: {
            TheTabViewLoading,
            TheLoading,
            ThePageError
        },
        data() {
            return {
                indexColumnCellRefs: [] as any[],
                mainTableRef: null as any,
                pageError: '',
                isVisible: false,
                isLoading: false,
                isPageLoading: false,
                companyReportSheetsTimeout: 0,
                valueTimeout: 0,
                sheetIndex: 0,
                companyReportSheets: [] as any[],
                header: null as any,
                componentHeader: null as any,
                navigateRowIndex: 0,
                navigateColumnIndex: 0,
                navigateValue: null,
                tableWidth: 0,
                columnHeaders: [] as any[],
                isHorizontalScrollbar: false,
                commentDialog: {rowIndex: 0, columnIndex: 0, comment: null as any, visible: false, loading: false},
                saveDialog: {visible: false, loading: false},
                intercompanyDialog: {visible: false, sheetCodes: [] as any[], sheetIndexes: [] as any[], reversals: [] as any[]},
                companies: [] as any[],
                companyDropdownCompanies: [] as any[],
                filteredCompanies: [] as any[],
                countries: [] as any[],
                currencies: [] as any[],
                intercompanySheets: [] as any[],
                isCompanyLoading: false,
                isCompanyDropdownLoading: false,
                isCountryLoading: false,
                isCurrencyLoading: false,
                zoomLevel: 1.0,
                zoomFactor: 0.1,
                unsavedIds: [] as any,
                foreignEditedSheetIndexes: [] as any[],
                foreignRecomputeTimeout: null as any,
                isForeignRecomputing: false,
                sheetHistory: [] as any[],
                autoSaved: false,
                intercompanyChecked: false,
                focusArea: {rowIndex: 0, columnIndex: 0},
                lastAccessedDetail: {pageIndex: -1, scrollDetail: {scrollTop: 0, scrollLeft: 0}, lastAccessedCell: {rowIndex: 0, columnIndex: 0}},
            };
        },
        props: {
            visible: {
                type: Boolean,
                required: true
            },
            loading: {
                type: Boolean,
                required: true,
            },
            identifier: {
                type: Number,
                required: false
            },
            name: {
                type: String,
                required: false
            },
            type: {
                type: String,
                required: true
            },
            balanceSheetDate: {
                type: String,
                required: false
            },
            currencyCode: {
                type: String,
                required: false
            },
            purpose: {
                type: String,
                required: false
            },
            id: {
                type: Number,
                required: false
            },
            companyId: {
                type: Number,
                required: false
            },
            templateIndex: {
                type: Number,
                required: false
            },
            status: {
                type: String,
                required: false
            },
            isUnsaved: {
                type: Boolean,
                required: false
            },
            isNearestThousandPreview: {
                type: Boolean,
                required: false
            },
            isConsolidated: {
                type: Boolean,
                required: false
            },
            isFromApproval: {
                type: Boolean,
                required: false
            },
            reportSheets: {
                type: Array,
                required: false
            }
        },
        watch: {
            visible(newValue: any) {
                this.isVisible = newValue;

                this.sheetIndex = 0;
                this.companyReportSheets = [];
                this.header = null as any;
                this.componentHeader = null as any;
                this.navigateRowIndex = 0;
                this.navigateColumnIndex = 0;
                this.navigateValue = null;
                // Treat a nearest-thousand conversion preview as having pending changes so closing the
                // dialog always prompts Save / Discard, letting the user explicitly keep or ignore the
                // converted values (Discard reverts to the original data via deleteCached).
                this.autoSaved = !!(newValue && this.isNearestThousandPreview);
                this.intercompanyChecked = false;
                this.closeIntercompanyDialog();
                this.lastAccessedDetail.pageIndex = -1;

                if (this.isVisible) {
                    if (this.identifier != null) {
                        if (this.reportSheets == null) {
                            this.isPageLoading = true;

                            companyReportSheetApi.companyReportSheetViewByCompanyReportId(this.identifier, this.type, this.templateIndex)
                                .then(response => {
                                    this.companyReportSheets = response.data.listSet;

                                    if (response.data.lastAccessedDetail != null) {
                                        this.lastAccessedDetail = response.data.lastAccessedDetail;
                                        this.navigateValue = this.companyReportSheets[response.data.lastAccessedDetail.pageIndex];
                                    }

                                    this.companyReportSheetsTimeout = setTimeout(() => {
                                        var r = [] as any[];
                                        this.companyReportSheets.forEach((companyReportSheet: any, index: any) => {
                                            companyReportSheet.sheetError = '';

                                            r.push(companyReportSheetTemplateApi.companyReportSheetTemplateViewByCompanyReportSheet(this.templateIndex, companyReportSheet.identifier, {identifier: this.identifier, isUnsaved: this.isUnsaved})
                                                .catch(error => {
                                                    companyReportSheet.sheetError = error;
                                                }));
                                        });

                                        Promise.all(r)
                                            .then((values: any) => {
                                                if (values != null) {
                                                    for (var i = 0; i < values.length; i++) {
                                                        if (values[i] != null && values[i].data != null) {
                                                            this.companyReportSheets[i].template = values[i].data.content.template;

                                                            this.companyReportSheets[i].navigateChilds = [];
                                                            if (values[i].data.function != null && values[i].data.function.navigateChilds != null) {
                                                                this.companyReportSheets[i].navigateChilds = values[i].data.function.navigateChilds;
                                                                if (this.type == 'cwk' && i == 1) {
                                                                    this.companyReportSheets[i].navigateChilds.push(87);
                                                                }
                                                            }
                                                            this.companyReportSheets[i].sheet.index = this.companyReportSheets[i].sheet_sequence;

                                                            this.setComponents(this.companyReportSheets, i, true);

                                                            if (i == 0 && this.lastAccessedDetail.pageIndex == -1) {
                                                                this.setLongComponent(false);
                                                                this.calculateTableWidthHeight();
                                                            }
                                                        }
                                                    }

                                                    this.isPageLoading = false;

                                                    if (this.navigateValue != null) {
                                                        this.onNavigateChange(true, null);
                                                    }

                                                    this.tryAutoCorrectIntercompanyOrder();
                                                }
                                            })
                                            .catch(error => {
                                                this.pageError = error;
                                                this.isPageLoading = false;
                                            })
                                            .finally(() => {
                                                r = [];
                                                this.syncCellHeights();
                                            });
                                    }, 0);
                                })
                                .catch(error => {
                                    this.pageError = error;
                                    this.isPageLoading = false;
                                });

                            this.refreshInterCompanyDropdown(this.filterLegalGroupId, this.companyId);
                            this.refreshDropdown();
                        }

                        else {
                            this.isPageLoading = true;

                            this.companyReportSheets = this.reportSheets as any;

                            let r1 = companyApi.companyList({isRpk: true, isSheetDialog: true}, this.filterLegalGroupId);

                            let r2 = countryApi.countryList(null);

                            let r3 = currencyApi.currencyList(null);

                            let r4 = eliminationSettingApi.eliminationSettingList(null);

                            Promise.all([r2, r3, r4])
                                .then((values: any) => {
                                    if (values != null) {
                                        for (var i = 0; i < values.length; i++) {
                                            if (i == 0) {
                                                this.companyDropdownCompanies = values[i].data.listSet;
                                            }

                                            /*else*/ if (i == 0) {
                                                this.countries = values[i].data.listSet;
                                            }

                                            else if (i == 1) {
                                                this.currencies = values[i].data.listSet;
                                            }

                                            else if (i == 2) {
                                                this.intercompanySheets = values[i].data.listSet;
                                            }
                                        }

                                        this.setLongComponent(false);
                                        this.calculateTableWidthHeight();

                                        this.refreshInterCompanyDropdown(this.filterLegalGroupId, this.companyId);
                                        this.refreshDropdown();

                                        this.isPageLoading = false;
                                        this.save(null);
                                    }
                                })
                                .catch(error => {
                                    this.pageError = error;
                                    this.isPageLoading = false;
                                });
                        }
                    }
                }

                else {
                    this.saveDialog.visible = false;
                    this.sheetHistory = [];
                    this.unsavedIds = [];
                    this.columnHeaders = [];
                    this.componentHeader = null as any;
                    this.header = null as any;
                    this.companyReportSheets = [];
                }
            },
            loading(newValue: any) {
                this.isLoading = newValue;
            },
            sheetIndex(newValue: any) {
                this.header = null as any;
                this.componentHeader = null as any;
                this.setLongComponent(false);
            },
            zoomLevel(newValue: any) {
                this.setHorizontalScrollbar();
            }
        },
        unmounted() {
            window.removeEventListener("resize", this.setHorizontalScrollbar);
        },
        mounted: function () {
            window.addEventListener("resize", this.setHorizontalScrollbar);
            if (this.pageError == '') {
                this.refreshInterCompanyDropdown(this.filterLegalGroupId, this.companyId);
                this.refreshDropdown();
            }
        },
        computed: {
            shortcutMenuItems() {
                return [
                    {
                        label: 'Cover: Reporting Package',
                        command: () => {
                            this.findNavigateValue("cover");
                            this.onNavigateChange(false, null);
                        }
                    },
                    {
                        label: 'PL: Statement of Comprehensive Income',
                        command: () => {
                            this.findNavigateValue("PL");
                            this.onNavigateChange(false, null);
                        }
                    },
                    {
                        label: 'BS: Statement of Financial Position',
                        command: () => {
                            this.findNavigateValue("BS");
                            this.onNavigateChange(false, null);
                        }
                    },
                    {
                        label: 'CF: Statement of Cash Flow',
                        command: () => {
                            this.findNavigateValue("CF");
                            this.onNavigateChange(false, null);
                        }
                    },
                    {
                        label: 'Eqty: Statement of Changes in Equity',
                        command: () => {
                            this.findNavigateValue("Eqty");
                            this.onNavigateChange(false, null);
                        }
                    }
                ]
            },
            isEditable() {
                // return true
                return (!this.isViewer && (this.status == 'Created' || this.status == 'Rejected' || (this.isFromApproval != null && this.isFromApproval)));
            },
            filterLegalGroupId() {
                return (store.getters.getFilterLegalGroupModel != null ? store.getters.getFilterLegalGroupModel.identifier : null);
            },
            firstColumnWidth() {
                // Column A holds the row labels. RPK puts intercompany company names there, which are
                // longer than the CWK labels, so give it extra room.
                return this.type === 'rpk' ? 34 : 27;
            },
            visibleColumnHeaders() {
                var result = [] as any[];
                for (var i = 0; i < this.columnHeaders.length; i++) {
                    if (this.invalidColumnIndexes.has(i)) continue;
                    result.push({header: this.columnHeaders[i].header, columnIndex: i});
                }
                return result;
            },
            invalidColumnIndexes() {
                var indexes = new Set<number>();
                if (this.type != 'cwk') return indexes;
                if (this.companyReportSheets.length == 0 || this.companyReportSheets[this.sheetIndex] == null) return indexes;
                var template = this.companyReportSheets[this.sheetIndex].template;
                if (template == null || template.length < 3) return indexes;
                var headerRow = template[0];
                var currencyRow = template[2];
                if (headerRow == null || headerRow.columns == null) return indexes;

                for (var i = 6; i < headerRow.columns.length; i++) {
                    // For foreign template (templateIndex == 2), FX pair columns (odd index) carry no currency
                    // on row 2 — their visibility mirrors the paired value column at (i - 1).
                    if (this.templateIndex == 2 && i % 2 == 1) {
                        if (indexes.has(i - 1)) indexes.add(i);
                        continue;
                    }
                    var headerCol = headerRow.columns[i];
                    var currencyCol = currencyRow != null && currencyRow.columns != null ? currencyRow.columns[i] : null;
                    var currencyValue = currencyCol != null ? currencyCol.value : null;
                    if (currencyValue == null || currencyValue === '') {
                        indexes.add(i);
                        continue;
                    }
                    // For foreign template (templateIndex == 2), every inserted column represents an
                    // actually-loaded foreign detail (RPK or sub-CWK). Sub-CWKs whose parent company is
                    // virtual would otherwise be hidden here, so skip the virtual check for template 2.
                    if (this.templateIndex != 2 && headerCol != null && headerCol.value) {
                        var matched = this.companyDropdownCompanies.find((c: any) => c.code == headerCol.value);
                        if (matched != null && matched.isVirtual) {
                            indexes.add(i);
                        }
                    }
                }
                return indexes;
            },
            debitCompanies() {
                var intercompanySheet = null as any;
                try {
                    intercompanySheet = this.intercompanySheets.map((interCo: any) => interCo.sheets.find((sheet: any) => sheet.code == this.companyReportSheets[this.sheetIndex].sheet_code)).filter((sheet: any) => sheet != null)[0];
                    if (intercompanySheet != null) {
                        if (this.isConsolidated) {
                            if (intercompanySheet.type == 'Credit') {
                                return this.companies.filter((company: any) => company.name != this.name);
                            }
                            else {
                                return this.companies;
                            }
                        }

                        else {
                            if (intercompanySheet.type == 'Credit') {
                                return this.companies.filter((company: any) => company.name != this.name);
                            }
                            else {
                                return this.companies.filter((company: any) => company.name == this.name);
                            }
                        }
                    }
                    return this.companies;
                }

                finally {
                    intercompanySheet = null;
                }
            },
            creditCompanies() {
                var intercompanySheet = null as any;
                try {
                    intercompanySheet = this.intercompanySheets.map((interCo: any) => interCo.sheets.find((sheet: any) => sheet.code == this.companyReportSheets[this.sheetIndex].sheet_code)).filter((sheet: any) => sheet != null)[0];
                    if (intercompanySheet != null) {
                        if (this.isConsolidated) {
                            if (intercompanySheet.type == 'Credit') {
                                return this.companies;
                            }
                            else {
                                return this.companies.filter((company: any) => company.name != this.name);
                            }
                        }
                        else {
                            if (intercompanySheet.type == 'Credit') {
                                return this.companies.filter((company: any) => company.name == this.name);
                            }
                            else {
                                return this.companies.filter((company: any) => company.name != this.name);
                            }
                        }
                    }
                    return this.companies;
                }

                finally {
                    intercompanySheet = null;
                }
            },
        },
        methods: {
            format,
            parse,
            formatDateObject(dateObj: any) {
                if (!dateObj) return null;
                return format(dateObj, 'dd/MM/yyyy');
            },            
            getPercentageDisplayValue(column: any) {
                if (!column) return 0;
                return column.settings?.isPercentage
                    ? ((column.actualValue ?? 0) * 100)
                    : (column.actualValue ?? 0);
            },
            getPercentageStoredValue(column: any, input: any) {
                return column.settings?.isPercentage ? input / 100 : input;
                },
            /**
             * Get the cell colspan if component is LONGLABEL or LONGTEXT.
             */
            getCellColspan(rowIndex: any, columnIndex: any){
                const cell = this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[columnIndex];
                const isLongComponent = cell.component == 'LONGLABEL' || cell.component == 'LONGTEXT';
                if (!isLongComponent) return undefined;

                return 'settings' in cell && 'colspan' in cell.settings ? cell.settings.colspan : this.columnHeaders.length - columnIndex;
            },
            /**
             * Get the display value of the cell. Set to none if cell in merged cell range, else display as normal.
             */
            getCellDisplay(rowIndex: any, columnIndex: any) {
                const row = this.companyReportSheets[this.sheetIndex].template[rowIndex].columns;
                for (let i = columnIndex - 1; i >= 0; i--) {
                    const prev = row[i];
                    if (prev?.component == 'LONGLABEL' || prev?.component == 'LONGTEXT') {
                        const span = 'settings' in prev && 'colspan' in prev.settings ? prev.settings.colspan : this.columnHeaders.length - i;
                        if (i + span > columnIndex) {
                            return 'display: none';
                        }
                    }
                }
                return '';
            },      
            findNavigateValue(code: any) {
                this.companyReportSheets.forEach((companyReportSheet: any) => {
                    if (companyReportSheet.sheet_code == code) {
                        this.navigateValue = companyReportSheet;
                    }
                })
            },
            refreshInterCompanyDropdown(legalGroupId: any, companyId: any) {
                this.isCompanyLoading = true;
                companyApi.companySingleTreeList({isRpk: true, isSheetDialog: true, companyId: companyId}, legalGroupId)
                    .then(response => {
                        this.companies = response.data.listSet;
                        this.isCompanyLoading = false;
                        this.tryAutoCorrectIntercompanyOrder();
                    })
                    .catch(error => {
                        this.pageError = error;
                        this.isCompanyLoading = false;
                    });
            },
            refreshDropdown() {
                this.isCompanyDropdownLoading = true;
                companyApi.companyList({isRpk: true}, this.filterLegalGroupId)
                    .then(response => {
                        this.companyDropdownCompanies = response.data.listSet;

                        this.isCompanyDropdownLoading = false;
                    })
                    .catch(error => {
                        this.pageError = error;
                        this.isCompanyDropdownLoading = false;
                    });

                this.isCountryLoading = true;
                countryApi.countryList(null)
                    .then(response => {
                        this.countries = response.data.listSet;

                        this.isCountryLoading = false;

                    })
                    .catch(error => {
                        this.pageError = error;
                        this.isCountryLoading = false;
                    });

                this.isCurrencyLoading = true;
                currencyApi.currencyList(null)
                    .then(response => {
                        this.currencies = response.data.listSet;

                        this.isCurrencyLoading = false;
                    })
                    .catch(error => {
                        this.pageError = error;
                        this.isCurrencyLoading = false;
                    });

                eliminationSettingApi.eliminationSettingList(null)
                    .then(response => {
                        this.intercompanySheets = response.data.listSet;
                        this.tryAutoCorrectIntercompanyOrder();
                    })
                    .catch(error => {
                        this.pageError = error;
                    });
            },
            getFractionDigitsFromSettings(settings: any) {
                if (settings && settings.decimalPlaces && settings.decimalPlaces != 'auto') {
                    return settings.decimalPlaces;
                }
                return null;
            },
            getLabelMaxWidth(rowIndex: any, columnIndex: any) {
                if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns.length > columnIndex + 2) {
                    if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[columnIndex + 1].component == 'NUMBER' || this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[columnIndex + 1].component == 'TEXT') {
                        return '100';
                    }

                    else if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[columnIndex + 2].component == 'NUMBER' || this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[columnIndex + 2].component == 'TEXT') {
                        return '200';
                    }
                }
                return 'max';
            },
            setComponentHeader() {
                this.header = null as any;
                this.componentHeader = null as any;

                if (this.companyReportSheets[this.sheetIndex] != null && this.companyReportSheets[this.sheetIndex].template != null && this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex] != null && this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[this.focusArea.columnIndex] != null && this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[this.focusArea.columnIndex].header != null) {
                    this.header = this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[this.focusArea.columnIndex].header;

                    if (this.header.includes("R_")) {
                        if (this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[0].component == 'TEXT' || this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[0].component == 'FORMULA') {
                            if (this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[0].actualValue != null && this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[0].actualValue != '') {
                                this.header = this.header.replace('{R_0}', this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[0].actualValue);
                            }

                            else {
                                this.header = this.header.replace('{R_0}', '');
                            }
                        }

                        else if (this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[0].component == 'COMPANY') {
                            if (this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[0].actualValue != null && this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[0].actualValue.debit != null && this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[0].actualValue.credit != null) {
                                this.header = this.header.replace('{R_0}', 'R' + (this.focusArea.rowIndex + 1) + 'C' + (this.focusArea.columnIndex + 1) + '[' + this.getHeader(this.focusArea.rowIndex, this.focusArea.columnIndex) + '] = ' + this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[0].actualValue.debit.name + '-' + this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[0].actualValue.credit.name + ' | ' + (this.companyReportSheets[this.sheetIndex].template[0].columns[this.focusArea.columnIndex].value != null ? this.companyReportSheets[this.sheetIndex].template[0].columns[this.focusArea.columnIndex].value : '') + (this.companyReportSheets[this.sheetIndex].template[1].columns[this.focusArea.columnIndex].value != null ? this.companyReportSheets[this.sheetIndex].template[1].columns[this.focusArea.columnIndex].value : ''));
                            }

                            else {
                                this.header = this.header.replace('{R_0}', '');
                            }
                        }

                        else if (this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[0].component == 'COMPANYDROPDOWN' ||this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[0].component == 'COUNTRY' || this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[0].component == 'CURRENCY') {
                            if (this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[0].actualValue != null) {
                                this.header = this.header.replace('{R_0}', this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[0].actualValue.name);
                            }

                            else {
                                this.header = this.header.replace('{R_0}', '');
                            }
                        }
                    }

                    if (this.header.includes("C_")) {
                        for (let i = 0; i < this.companyReportSheets[this.sheetIndex].template.length; i++) {
                            let header = "";
                            if (this.companyReportSheets[this.sheetIndex].template[i].columns[this.focusArea.columnIndex].component == 'HEADERTEXT') {
                                if (this.companyReportSheets[this.sheetIndex].template[i].columns[this.focusArea.columnIndex].actualValue != null && this.companyReportSheets[this.sheetIndex].template[i].columns[this.focusArea.columnIndex].actualValue != '') {
                                    header = " " + this.companyReportSheets[this.sheetIndex].template[i].columns[this.focusArea.columnIndex].actualValue;
                                    this.header = this.header.replace('{C_' + this.focusArea.columnIndex + '}', header);
                                }

                                else {
                                    header = " " + this.companyReportSheets[this.sheetIndex].template[i].columns[this.focusArea.columnIndex].value;
                                    this.header = this.header.replace('{C_' + this.focusArea.columnIndex + '}', header);
                                }
                            }
                        }
                    }

                    if (this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[this.focusArea.columnIndex].component == 'HEADERTEXT') {
                        for (let i = 0; i < this.companyReportSheets[this.sheetIndex].template.length; i++) {
                            if (this.companyReportSheets[this.sheetIndex].template[i].columns[this.focusArea.columnIndex].component == 'HEADERTEXT') {
                                if (this.companyReportSheets[this.sheetIndex].template[i].columns[this.focusArea.columnIndex].actualValue != null && this.companyReportSheets[this.sheetIndex].template[i].columns[this.focusArea.columnIndex].actualValue != '') {
                                    this.header = this.header.replace(this.companyReportSheets[this.sheetIndex].template[i].columns[this.focusArea.columnIndex].value, this.companyReportSheets[this.sheetIndex].template[i].columns[this.focusArea.columnIndex].actualValue);
                                }
                            }
                        }
                    }

                    this.componentHeader = this.header;
                }
            },
            getBorder(rowIndex: any) {
                if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns != null) {
                    for (var i = 0; i < this.companyReportSheets[this.sheetIndex].template[rowIndex].columns.length; i++) {
                        if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[i].style != null) {
                            if ("border-top-width" in this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[i].style && "border-bottom-width" in this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[i].style) {
                                if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[i].style["border-top-width"] == "1.5px") {
                                    return 'single-2-lines';
                                }

                                else if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[i].style["border-top-width"] == "4px") {
                                    return 'double-2-lines';
                                }
                            }

                            else if ("border-top-width" in this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[i].style) {
                                if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[i].style["border-top-width"] == "1.5px") {
                                    return 'single-line';
                                }

                                else if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[i].style["border-top-width"] == "4px") {
                                    return 'double-line';
                                }
                            }

                            else if ("border-bottom-width" in this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[i].style) {
                                if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[i].style["border-bottom-width"] == "1.5px") {
                                    return 'single-line';
                                }

                                else if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[i].style["border-bottom-width"] == "4px") {
                                    return 'double-line';
                                }
                            }
                        }
                    }
                }
            },
            scrollScrollbar(rowIndex: any, columnIndex: any) {
                setTimeout(() => {
                    var sheetHeight = document.getElementsByClassName('p-dialog')[0].clientHeight - (document.getElementsByClassName('p-dialog-header')[0].clientHeight) - 41.33;
                    var sheetWidth = document.getElementsByClassName('p-dialog')[0].clientWidth - 64;

                    document.getElementsByClassName('p-dialog-content')[0].scrollTop = ((rowIndex) < Math.round(sheetHeight / 39.44)) ? 0 : (((rowIndex) - (Math.round((sheetHeight / 39.44)) / 2)) * 39.44) + 41.33;
                    document.getElementsByClassName('p-dialog-content')[0].scrollLeft = ((columnIndex + 2) < (Math.round(sheetWidth / 143.29))) ? 0 : (((columnIndex + 2) - ((Math.round(sheetWidth / 143.29)) / 2)) * 143.29) + 64;
                }, 0);
            },
            setLongComponent(isFromCached: any) {
                if (isFromCached) {
                    setTimeout(() => {
                        if (document.getElementsByClassName('p-dialog-content')[0]) {
                            document.getElementsByClassName('p-dialog-content')[0].scrollTop = this.lastAccessedDetail.scrollDetail.scrollTop;
                            document.getElementsByClassName('p-dialog-content')[0].scrollLeft = this.lastAccessedDetail.scrollDetail.scrollLeft;
                        }

                        this.onFocusChange(this.lastAccessedDetail.lastAccessedCell.rowIndex, this.lastAccessedDetail.lastAccessedCell.columnIndex);
                    }, 0);
                }
                this.setHorizontalScrollbar();
            },
            setHorizontalScrollbar() {
                this.isHorizontalScrollbar = ((this.tableWidth + (this.columnHeaders.length * ((this.zoomLevel * 10) - 10))) * 16) > document.body.clientWidth;
                nextTick(() => { this.syncCellHeights() });
            },
            syncCellHeights() {
                nextTick(() => {
                    if (this.mainTableRef != null) {
                        const table = this.mainTableRef.$el;
                        const rows = table.querySelectorAll('.p-datatable-tbody > tr');

                        rows.forEach((el: any, rowIndex: any) => {
                                const indexColumnCell = this.indexColumnCellRefs[rowIndex] as any;
                                if (!indexColumnCell) return;

                                const height = el.getBoundingClientRect().height;
                                indexColumnCell.closest('td').style.setProperty('height', height + 'px', 'important');
                        })
                    }
                })
            },
            registerIndexColumnCellRef(el: any, rowIndex: any) {
                if (!el) return;
                this.indexColumnCellRefs[rowIndex] = el;
            }, 
            registerMainTableRef(el: any){
                if (!el) return;
                this.mainTableRef = el;
            },
            calculateTableWidthHeight() {
                this.setColumnHeaders(this.companyReportSheets[this.sheetIndex].template);

                this.setHorizontalScrollbar();
            },
            setColumnHeaders(template: any) {
                this.columnHeaders = [];
                if (template != null && template.length > 0) {
                    for (var i = 0; i < template[0].columns.length; i++) {
                        this.columnHeaders.push({'header': this.getHeaderLetter(i)});
                    }

                    // 4rem index column + 9rem per column + the extra column A gets over a normal column.
                    this.tableWidth = 4 + (this.columnHeaders.length * 9) + (this.firstColumnWidth - 9);
                }

                else {
                    this.tableWidth = 20;
                }
            },
            changeNumberValue(rowIndex: any, columnIndex: any, isClearTimeout: any) {
                if (isClearTimeout) {
                    clearTimeout(this.valueTimeout);
                }
                this.valueTimeout = setTimeout(() => {
                    var newValue = this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[columnIndex].actualValue;
                    var header = this.getHeader(rowIndex, columnIndex);
                    var isFixedRate = false;

                    if (!isNaN(newValue)) {
                        if (this.type == 'cwk') {
                            isFixedRate = true;
                        }
                        // The CWK foreign sheet (template 2) is recomputed on the backend, which is
                        // authoritative for it: its cross-page aggregates cannot be reliably refreshed by
                        // client-side event-propagation. Skip propagation and schedule a debounced backend
                        // recompute that refreshes every dependent value correctly.
                        if (this.isForeignSheet()) {
                            this.scheduleForeignRecompute();
                        }
                        else {
                            this.changeFormulaValue(this.companyReportSheets, this.companyReportSheets[this.sheetIndex].sheet_code, header, newValue, this.companyReportSheets[this.sheetIndex].formulas[header], this.sheetIndex, true, isFixedRate);
                            this.changeNavigateValue(this.companyReportSheets, this.companyReportSheets[this.sheetIndex].sheet_code, header, newValue, this.sheetIndex, true, isFixedRate);
                            this.changeFormulaNavigateValue(this.companyReportSheets, this.companyReportSheets[this.sheetIndex].sheet_code, header, newValue, this.sheetIndex, true, isFixedRate);
                        }
                    }

                    header = null as any;
                    newValue = null as any;
                }, 0);
            },
            changeTextValue(rowIndex: any, columnIndex: any, isClearTimeout: any) {
                if (isClearTimeout) {
                    clearTimeout(this.valueTimeout);
                }
                this.valueTimeout = setTimeout(() => {
                    var newValue = this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[columnIndex].actualValue;
                    var header = this.getHeader(rowIndex, columnIndex);

                    // See changeNumberValue: the foreign sheet is recomputed on the backend.
                    if (this.isForeignSheet()) {
                        this.scheduleForeignRecompute();
                    }
                    else {
                        this.changeFormulaValue(this.companyReportSheets, this.companyReportSheets[this.sheetIndex].sheet_code, header, newValue, this.companyReportSheets[this.sheetIndex].formulas[header], this.sheetIndex, true, false);
                        this.changeNavigateValue(this.companyReportSheets, this.companyReportSheets[this.sheetIndex].sheet_code, header, newValue, this.sheetIndex, true, false);
                        this.changeFormulaNavigateValue(this.companyReportSheets, this.companyReportSheets[this.sheetIndex].sheet_code, header, newValue, this.sheetIndex, true, false);
                    }

                    header = null as any;
                    newValue = null as any;
                }, 0);
            },
            isForeignSheet() {
                return this.type === 'cwk' && this.templateIndex === 2;
            },
            scheduleForeignRecompute() {
                // Remember which sheet was edited so its raw values get persisted before the recompute,
                // then debounce: recompute once the user pauses, not on every keystroke.
                if (!this.foreignEditedSheetIndexes.includes(this.sheetIndex)) {
                    this.foreignEditedSheetIndexes.push(this.sheetIndex);
                }
                clearTimeout(this.foreignRecomputeTimeout);
                this.foreignRecomputeTimeout = setTimeout(() => {
                    this.recalculateForeignAndRefresh();
                }, 1000);
            },
            recalculateForeignAndRefresh() {
                if (this.isViewer || this.identifier == null) {
                    return;
                }
                // If a recompute is already running, wait and retry so edits aren't lost or overlapped.
                if (this.isForeignRecomputing) {
                    this.foreignRecomputeTimeout = setTimeout(() => { this.recalculateForeignAndRefresh(); }, 500);
                    return;
                }
                if (this.foreignEditedSheetIndexes.length == 0) {
                    return;
                }
                this.isForeignRecomputing = true;
                // 1) Persist the edited foreign sheet(s) so the backend recompute reads the new raw values.
                var editedIndexes = JSON.parse(JSON.stringify(this.foreignEditedSheetIndexes));
                this.foreignEditedSheetIndexes = [];
                var saves = editedIndexes.map((index: any) => {
                    var sheet = this.companyReportSheets[index];
                    return companyReportSheetApi.companyReportSheetUpdate({identifier: this.identifier, companyReportSheet: {identifier: sheet.identifier, sheet: sheet.sheet, content: {template: sheet.template}}}, this.templateIndex);
                });
                Promise.all(saves)
                    .then(() => {
                        // 2) Recompute the whole foreign template on the backend (authoritative).
                        return companyReportApi.companyReportCalculateForeign({companyReport: {identifier: this.identifier}}, 'cwk');
                    })
                    .then((response: any) => {
                        // 3) Refresh every sheet's values from the single response (no per-sheet re-fetch).
                        if (response != null && response.data != null && response.data.listSet != null) {
                            var contentBySheetId = {} as any;
                            response.data.listSet.forEach((item: any) => { contentBySheetId[item.identifier] = item.content; });
                            this.companyReportSheets.forEach((companyReportSheet: any) => {
                                var content = contentBySheetId[companyReportSheet.identifier];
                                if (content != null && content.template != null) {
                                    // Only values change (formula cells recomputed by the backend); updating
                                    // template refreshes the display reactively. Rebuild the dependency maps
                                    // only for the visible sheet, in case the user edits it again.
                                    companyReportSheet.template = content.template;
                                }
                            });
                            this.setComponents(this.companyReportSheets, this.sheetIndex, false);
                        }
                        this.isForeignRecomputing = false;
                    })
                    .catch((error: any) => {
                        this.isForeignRecomputing = false;
                        this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
                    });
            },
            navigateCellComponent(rowIndex: any, columnIndex: any) {
                var value = this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[columnIndex].value;

                if (value != null) {
                    store.state.keyPressedTime = Date.now();

                    this.sheetHistory.push({'sheetIndex': this.sheetIndex, 'lastAccessed': {'scrollTop': document.getElementsByClassName('p-dialog-content')[0].scrollTop, 'scrollLeft': document.getElementsByClassName('p-dialog-content')[0].scrollLeft, 'rowIndex': rowIndex, 'columnIndex': columnIndex}});
                    var keys = value.split('!');
                    var code = (value.match(/([A-Za-z0-9_]+)!/g))![0].replace('!', '');

                    var targetRowIndex = this.getRowIndex(keys[1]);
                    var targetColIndex = this.getColumnIndex(keys[1]);

                    var sheetIndex = this.companyReportSheets.findIndex(x => x.sheet_code == code && x.template != null);
                    if (sheetIndex != -1) {
                        this.navigateValue = this.companyReportSheets[sheetIndex];
                        this.onNavigateChange(false, null);

                        this.scrollScrollbar(targetRowIndex, targetColIndex);

                        setTimeout(() => {
                            this.onFocusChange(targetRowIndex, targetColIndex);
                        }, 0);
                    }
                    code = null as any;
                    keys = null as any;
                }
            },
            onNavigateBack() {
                if (this.sheetHistory.length > 0) {
                    var currentSheetHistory = this.sheetHistory.pop();
                    this.navigateValue = this.companyReportSheets[currentSheetHistory.sheetIndex];
                    this.onNavigateChange(false, currentSheetHistory);

                    setTimeout(() => {
                        this.onFocusChange(currentSheetHistory.lastAccessed.rowIndex, currentSheetHistory.lastAccessed.columnIndex);
                        currentSheetHistory = null;
                    }, 0);
                }
            },
            onNavigatePrev() {
                // this.zoomLevel = 1;
                this.sheetIndex -= 1;
                if (this.sheetIndex < 0) {
                    this.sheetIndex = this.companyReportSheets.length - 1;
                }
                this.navigateValue = this.companyReportSheets[this.sheetIndex];
                this.calculateTableWidthHeight();

                document.getElementsByClassName('p-dialog-content')[0].scrollTo(0, 0);
            },
            onNavigateNext() {
                // this.zoomLevel = 1;
                this.sheetIndex += 1;
                if (this.sheetIndex > this.companyReportSheets.length - 1) {
                    this.sheetIndex = 0;
                }
                this.navigateValue = this.companyReportSheets[this.sheetIndex];

                this.calculateTableWidthHeight();

                document.getElementsByClassName('p-dialog-content')[0].scrollTo(0, 0);
            },
            onNavigateChange(isFromCached: any, sheetHistory: any) {
                // this.zoomLevel = 1;
                if (this.navigateValue != null) {
                    store.state.keyPressedTime = Date.now();

                    this.sheetIndex = this.companyReportSheets.indexOf(this.navigateValue);
                    this.navigateValue = this.companyReportSheets[this.sheetIndex];

                    if (isFromCached) {
                        this.setLongComponent(true);
                    }

                    this.calculateTableWidthHeight();

                    if (!isFromCached) {
                        setTimeout(() => {
                            sheetHistory != null ? document.getElementsByClassName('p-dialog-content')[0].scrollTo(sheetHistory.lastAccessed.scrollLeft, sheetHistory.lastAccessed.scrollTop) : document.getElementsByClassName('p-dialog-content')[0].scrollTo(0, 0);
                        }, 0);
                    }

                    store.state.keyPressedTime = Date.now();
                }
            },
            tryAutoCorrectIntercompanyOrder() {
                // Detect reversed debit/credit company order on RPK COMPANY rows when the report is
                // first opened, and if any are found, prompt the user to choose whether to correct
                // them (see applyIntercompanyCorrection / declineIntercompanyCorrection). The required
                // data (templates, company tree, elimination settings, report company name) loads via
                // several independent async calls, so this is invoked from each completion point and
                // only runs once everything is ready.
                if (this.intercompanyChecked || this.type != 'rpk') {
                    return;
                }
                var templatesLoaded = this.companyReportSheets != null && this.companyReportSheets.length > 0 && this.companyReportSheets.every((sheet: any) => sheet.template != null);
                if (!templatesLoaded || this.companies == null || this.companies.length == 0 || this.intercompanySheets == null || this.intercompanySheets.length == 0 || this.name == null) {
                    return;
                }
                this.intercompanyChecked = true;

                var reversals = [] as any[];
                var sheetCodes = [] as any[];
                var sheetIndexes = [] as any[];
                this.companyReportSheets.forEach((companyReportSheet: any, index: any) => {
                    if (companyReportSheet == null || companyReportSheet.template == null) {
                        return;
                    }
                    // Resolve whether this sheet is the debit or credit side of an elimination pair.
                    var intercompanySheet = this.intercompanySheets.map((interCo: any) => interCo.sheets.find((sheet: any) => sheet.code == companyReportSheet.sheet_code)).filter((sheet: any) => sheet != null)[0];
                    if (intercompanySheet == null) {
                        return;
                    }

                    var isSheetReversed = false;
                    companyReportSheet.template.forEach((row: any) => {
                        var column = row.columns[0];
                        if (column == null || column.component != 'COMPANY' || !column.isChild || column.actualValue == null) {
                            return;
                        }
                        var debit = column.actualValue.debit;
                        var credit = column.actualValue.credit;
                        if (debit == null || credit == null) {
                            return;
                        }
                        // Anchor rule: the report's own company must sit on the debit side of a
                        // Debit sheet and on the credit side of a Credit sheet. If it is found on
                        // the wrong side (and the other side is not the report company), the pair
                        // was imported in reverse.
                        var isReversed = false;
                        if (intercompanySheet.type == 'Debit') {
                            if (credit.name == this.name && debit.name != this.name) {
                                isReversed = true;
                            }
                        }
                        else if (intercompanySheet.type == 'Credit') {
                            if (debit.name == this.name && credit.name != this.name) {
                                isReversed = true;
                            }
                        }
                        if (isReversed) {
                            // Record the cell so the swap can be applied later if the user accepts.
                            reversals.push({column: column, debit: debit, credit: credit});
                            isSheetReversed = true;
                        }
                    });

                    if (isSheetReversed) {
                        if (!sheetCodes.includes(companyReportSheet.sheet_code)) {
                            sheetCodes.push(companyReportSheet.sheet_code);
                        }
                        if (!sheetIndexes.includes(index)) {
                            sheetIndexes.push(index);
                        }
                    }
                });

                if (reversals.length > 0) {
                    // Let the user decide whether to apply the correction. Nothing is changed yet.
                    this.intercompanyDialog.reversals = reversals;
                    this.intercompanyDialog.sheetCodes = sheetCodes;
                    this.intercompanyDialog.sheetIndexes = sheetIndexes;
                    this.intercompanyDialog.visible = true;
                }
            },
            applyIntercompanyCorrection() {
                // User chose to proceed: switch debit/credit on each detected cell. This is kept
                // in-memory only (marked as unsaved) and is not persisted to the database until the
                // user performs a Save action.
                this.intercompanyDialog.reversals.forEach((reversal: any) => {
                    reversal.column.actualValue.debit = reversal.credit;
                    reversal.column.actualValue.credit = reversal.debit;
                });
                this.intercompanyDialog.sheetIndexes.forEach((index: any) => {
                    if (!this.unsavedIds.includes(index)) {
                        this.unsavedIds.push(index);
                    }
                });
                if (this.intercompanyDialog.sheetIndexes.length > 0) {
                    // Flag the report as having unsaved changes so the user is prompted to save.
                    this.autoSaved = true;
                }
                var correctedSheetCodes = this.intercompanyDialog.sheetCodes.join(", ");
                this.closeIntercompanyDialog();
                this.$toast.add({
                    severity: "warn",
                    summary: "Intercompany order corrected",
                    detail: "Corrected reversed debit/credit company order in: " + correctedSheetCodes + ". Please Save to persist the changes.",
                    life: 12000
                });
            },
            declineIntercompanyCorrection() {
                // User chose not to correct: leave the data as imported. Nothing is changed or saved.
                this.closeIntercompanyDialog();
            },
            closeIntercompanyDialog() {
                this.intercompanyDialog.visible = false;
                this.intercompanyDialog.reversals = [];
                this.intercompanyDialog.sheetCodes = [];
                this.intercompanyDialog.sheetIndexes = [];
            },
            save(isNearestThousand:any) {
                this.autoSaved = false;
                this.updateDateTime();
                const isUpdateLocalSheet = this.type === 'cwk' && this.templateIndex === 2;
                this.$emit('save', this.companyReportSheets, false, isNearestThousand, isUpdateLocalSheet);
            },
            updateDateTime(){
                for (let i = 0; i < this.companyReportSheets.length; i++) {
                    const template = this.companyReportSheets[i].template;
                    for (let j = 0; j < template.length; j++){
						for (let k = 0; k < template[j].columns.length; k++){
                            if (template[j].columns[k].component == 'DATETIME' && (template[j].columns[k].value == null || template[j].columns[k].value == '')) {
                                template[j].columns[k].actualValue = format(new Date(), "dd/MM/yyyy' 'HH:mm:ss");
                            }
                        }
                    }
                }
			},
            autoSave(sheetIndex: any) {
                if (!this.isViewer && (this.status == 'Created' || this.status == 'Rejected' || (this.isFromApproval != null && this.isFromApproval))) {
                    setTimeout(() => {
                        var unsavedIds = null as any;
                        try {
                            this.$emit('autoSave', this.companyReportSheets[sheetIndex], this.sheetIndex, document.getElementsByClassName('p-dialog-content')[0].scrollTop, document.getElementsByClassName('p-dialog-content')[0].scrollLeft, this.focusArea);
                            this.autoSaved = true;
                            unsavedIds = JSON.parse(JSON.stringify(this.unsavedIds));
                            unsavedIds.forEach((unsavedId: any, index: any) => {
                                this.$emit('autoSave', this.companyReportSheets[unsavedId], null, null, null, null);
                                this.unsavedIds.splice(index, 1);
                            });
                        }

                        catch (err) {
                            console.log(err);
                        }

                        finally {
                            unsavedIds = null as any;
                        }
                    }, 0);
                }
            },
            cancel() {
                if (this.autoSaved && !this.isViewer) {
                    this.saveDialog.visible = true;
                }

                else {
                    this.clearTimeoutAndReset();
                    this.$emit('cancel', false, this.sheetIndex, document.getElementsByClassName('p-dialog-content')[0].scrollTop, document.getElementsByClassName('p-dialog-content')[0].scrollLeft, this.focusArea);
                }
            },
            saveChanges() {
                this.clearTimeoutAndReset();
                this.$emit('save', this.companyReportSheets, true, this.isNearestThousandPreview);
            },
            discardChanges() {
                this.clearTimeoutAndReset();
                this.$emit('deleteCached', this.companyReportSheets[this.sheetIndex], this.sheetIndex, document.getElementsByClassName('p-dialog-content')[0].scrollTop, document.getElementsByClassName('p-dialog-content')[0].scrollLeft, this.focusArea, true);
            },
            closeSave() {
                this.saveDialog.visible = false;
            },
            clearTimeoutAndReset() {
                clearTimeout(this.valueTimeout);
                clearTimeout(this.companyReportSheetsTimeout);

                for (var i = 0; i <= this.companyReportSheets.length - 1; i++) {
                    if (this.companyReportSheets[i].componentsTimeout != null) {
                        this.companyReportSheets[i].componentsTimeout = clearTimeout(this.companyReportSheets[i].componentsTimeout);
                    }
                }

                this.removeKeyPressDetection();
                // this.zoomLevel = 1;
            },
            resetZoom() {
                this.zoomLevel = 1;
            },
            zoomIn() {
                if (!(this.zoomLevel > 1.5)) {
                    this.zoomLevel += this.zoomFactor;
                }
            },
            zoomOut() {
                if (!(this.zoomLevel < 0.6)) {
                    this.zoomLevel -= this.zoomFactor;
                }
            },
            toggleComment(rowIndex: any, columnIndex: any) {
                this.commentDialog.rowIndex = rowIndex;
                this.commentDialog.columnIndex = columnIndex;
                this.commentDialog.comment = this.getCommentValue(this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[columnIndex].comment);
                const initComment = "[" + this.getCurrentUsername() + " " + this.formatToDateTime(new Date()) + "]\n";
                if (this.commentDialog.comment == null || this.commentDialog.comment == "") {
                    this.commentDialog.comment = initComment;
                } else { 
                    this.commentDialog.comment += "\n" + initComment;
                }

                this.commentDialog.visible = true;
            },
            removeComment() {
                this.companyReportSheets[this.sheetIndex].template[this.commentDialog.rowIndex].columns[this.commentDialog.columnIndex].comment = null;
                this.commentDialog.visible = false;
            },
            closeComment() {
                this.commentDialog.visible = false;
            },
            saveComment() {
                this.companyReportSheets[this.sheetIndex].template[this.commentDialog.rowIndex].columns[this.commentDialog.columnIndex].comment = {
                    value: this.commentDialog.comment,
                    lastModifiedBy: this.getCurrentUsername(),
                    time: this.formatToDateTime(new Date()),
                };
                this.commentDialog.visible = false;
            },
            getCommentValue(comment: any) {
                if (comment == null) {
                    return null;
                }
                if (typeof comment === 'string') {
                    return comment;
                }
                if (typeof comment === 'object' && 'value' in comment) {
                    return comment.value;
                }
                return null;
            },
            hasComment(comment: any) {
                const commentValue = this.getCommentValue(comment);
                return commentValue != null && commentValue !== '';
            },
            getCurrentUsername() {
                const session = store.getters.getSession;
                if (session != null && session.employee != null) {
                    return session.employee.name ?? session.employee.emailAddress ?? null;
                }
                return null;
            },
            insertCompany(key: any) {
                var columns = null as any;
                var component = null as any;
                var value = null as any;
                var formulas = null as any;
                var keys = null as any;
                var letterStart = null as any;
                var letterEnd = null as any;
                var startNumber = null as any;
                var endNumber = null as any;

                try {
                    var newIndex = key;
                    while (this.companyReportSheets[this.sheetIndex].template[newIndex + 1].columns[0].component == 'COMPANY') {
                        newIndex = newIndex + 1;
                    }

                    columns = [];
                    for (var i = 1; i <= this.companyReportSheets[this.sheetIndex].template[key].columns.length; i++) {
                        component = this.companyReportSheets[this.sheetIndex].template[key].columns[i - 1].component;
                        value = this.companyReportSheets[this.sheetIndex].template[key].columns[i - 1].value;
                        if (component == 'FORMULA' && value != null) {
                            value = value.replaceAll((key + 1), (newIndex + 2));
                        }

                        if (this.isConsolidated) {
                            var intercompanySheet = this.intercompanySheets.map((interCo: any) => interCo.sheets.find((sheet: any) => sheet.code == this.companyReportSheets[this.sheetIndex].sheet_code)).filter((sheet: any) => sheet != null)[0];
                            if (intercompanySheet != null && intercompanySheet.type == 'Credit') {
                                columns.push({'component': component, 'value': value, 'header': '{R_0}', 'actualValue': (component == 'COMPANY' ? {debit: null, credit: this.creditCompanies.filter((company: any) => company.name == this.name)[0]} : null), 'isChild': true});
                            }

                            else {
                                columns.push({'component': component, 'value': value, 'header': '{R_0}', 'actualValue': (component == 'COMPANY' ? {debit: this.debitCompanies.filter((company: any) => company.name == this.name)[0], credit: null} : null), 'isChild': true});
                            }
                        }

                        else {
                            columns.push({'component': component, 'value': value, 'header': '{R_0}', 'actualValue': (component == 'COMPANY' ? {debit: this.debitCompanies.length == 1 ? this.debitCompanies[0] : null, credit: this.creditCompanies.length == 1 ? this.creditCompanies[0] : null} : null), 'isChild': true});
                        }
                    }

                    this.companyReportSheets[this.sheetIndex].template.splice(newIndex + 1, 0, {'columns': columns});

                    for (var j = 0; j < this.companyReportSheets[this.sheetIndex].template.length; j++) {
                        for (var k = 0; k < this.companyReportSheets[this.sheetIndex].template[j].columns.length; k++) {
                            if (this.companyReportSheets[this.sheetIndex].template[j].columns[k].component == 'FORMULA' && this.companyReportSheets[this.sheetIndex].template[j].columns[k].value != null) {
                                formulas = this.parseToken(this.companyReportSheets[this.sheetIndex].template[j].columns[k].value.substring(1), j, k);
                                if (formulas != null && formulas.length > 0) {
                                    formulas.forEach((formula: any) => {
                                        if (formula.type == 'operand' && formula.subtype != 'text') {
                                            if (formula.subtype == 'range' && formula.value.indexOf(':') != -1) {
                                                keys = formula.value.split(':');

                                                letterStart = this.getLetter(keys[0]);
                                                letterEnd = this.getLetter(keys[1]);
                                                startNumber = this.getNumber(keys[0]);
                                                endNumber = this.getNumber(keys[1]);

                                                if (startNumber != endNumber) {
                                                    if (endNumber > (newIndex + 1)) {
                                                        this.companyReportSheets[this.sheetIndex].template[j].columns[k].value = this.companyReportSheets[this.sheetIndex].template[j].columns[k].value.replace((letterEnd + endNumber), letterEnd + (endNumber + 1));
                                                    }

                                                    if (startNumber > (newIndex + 1)) {
                                                        this.companyReportSheets[this.sheetIndex].template[j].columns[k].value = this.companyReportSheets[this.sheetIndex].template[j].columns[k].value.replace((letterStart + startNumber), letterStart + (startNumber + 1));
                                                    }
                                                }
                                            }

                                            else {
                                                letterStart = this.getLetter(formula.value);
                                                startNumber = this.getNumber(formula.value);

                                                this.companyReportSheets[this.sheetIndex].template[j].columns[k].value = this.companyReportSheets[this.sheetIndex].template[j].columns[k].value.replace((letterStart + startNumber), letterStart + (startNumber + 1));
                                            }
                                        }
                                    });
                                }
                            }

                            if (j > (newIndex + 1) && this.companyReportSheets[this.sheetIndex].template[j].columns[k].header != null) {
                                this.companyReportSheets[this.sheetIndex].template[j].columns[k].header = this.companyReportSheets[this.sheetIndex].template[j].columns[k].header.replaceAll(j, j + 1);
                            }
                        }
                    }
                    this.setComponents(this.companyReportSheets, this.sheetIndex, true);

                    this.updateOtherTemplate(newIndex, true);
                }

                finally {
                    endNumber = null;
                    startNumber = null;
                    letterEnd = null;
                    letterStart = null;
                    keys = null;
                    formulas = null;
                    value = null;
                    component = null;
                    columns = null;
                }
            },
            removeCompany(key: any) {
                var formulas = null as any;
                var keys = null as any;
                var letterStart = null as any;
                var letterEnd = null as any;
                var startNumber = null as any;
                var endNumber = null as any;

                try {
                    this.companyReportSheets[this.sheetIndex].template.splice(key, 1);

                    for (var j = key; j < this.companyReportSheets[this.sheetIndex].template.length; j++) {
                        for (var k = 0; k < this.companyReportSheets[this.sheetIndex].template[j].columns.length; k++) {
                            if (this.companyReportSheets[this.sheetIndex].template[j].columns[k].component == 'FORMULA' && this.companyReportSheets[this.sheetIndex].template[j].columns[k].value != null) {
                                formulas = this.parseToken(this.companyReportSheets[this.sheetIndex].template[j].columns[k].value.substring(1), j, k);
                                if (formulas != null && formulas.length > 0) {
                                    formulas.forEach((formula: any) => {
                                        if (formula.type == 'operand' && formula.subtype != 'text') {
                                            if (formula.subtype == 'range' && formula.value.indexOf(':') != -1) {
                                                keys = formula.value.split(':');

                                                letterStart = this.getLetter(keys[0]);
                                                letterEnd = this.getLetter(keys[1]);
                                                startNumber = this.getNumber(keys[0]);
                                                endNumber = this.getNumber(keys[1]);

                                                if (startNumber > (key)) {
                                                    this.companyReportSheets[this.sheetIndex].template[j].columns[k].value = this.companyReportSheets[this.sheetIndex].template[j].columns[k].value.replace((letterStart + startNumber), letterStart + (startNumber - 1));
                                                }

                                                if (endNumber > (key)) {
                                                    this.companyReportSheets[this.sheetIndex].template[j].columns[k].value = this.companyReportSheets[this.sheetIndex].template[j].columns[k].value.replace((letterEnd + endNumber), letterEnd + (endNumber - 1));
                                                }
                                            }

                                            else {
                                                letterStart = this.getLetter(formula.value);
                                                startNumber = this.getNumber(formula.value);

                                                this.companyReportSheets[this.sheetIndex].template[j].columns[k].value = this.companyReportSheets[this.sheetIndex].template[j].columns[k].value.replace((letterStart + startNumber), letterStart + (startNumber - 1));
                                            }
                                        }
                                    });
                                }
                            }

                            if (j >= (key) && this.companyReportSheets[this.sheetIndex].template[j].columns[k].header != null) {
                                this.companyReportSheets[this.sheetIndex].template[j].columns[k].header = this.companyReportSheets[this.sheetIndex].template[j].columns[k].header.replaceAll(j + 2, j + 1);
                            }
                        }
                    }
                    this.setComponents(this.companyReportSheets, this.sheetIndex, true);

                    this.updateOtherTemplate(key, false);

                    for (var l = key - 1; l < key; l++) {
                        for (var m = 0; m < this.companyReportSheets[this.sheetIndex].template[l].columns.length; m++) {
                            if (this.companyReportSheets[this.sheetIndex].template[l].columns[m].component == 'NUMBER' && this.companyReportSheets[this.sheetIndex].template[l].columns[m].value != null) {
                                this.changeNumberValue(l, m, true);
                            }
                        }
                    }
                }

                finally {
                    endNumber = null;
                    startNumber = null;
                    letterEnd = null;
                    letterStart = null;
                    keys = null;
                    formulas = null;
                }
            },
            updateOtherTemplate(key: any, isInsert: any) {
                this.companyReportSheets[this.sheetIndex].navigateChilds.forEach((navigateChild: any) => {
                    setTimeout(() => {
                        var cell = null as any;
                        var letter = null as any;
                        var number = null as any;

                        try {
                            this.companyReportSheets[navigateChild].template.forEach((row: any, rowIndex: any) => {
                                row.columns.forEach((item: any, columnIndex: any) => {
                                    if (item.component != null && item.value != null) {
                                        if (item.value.toString().includes(this.companyReportSheets[this.sheetIndex].sheet_code + '!')) {
                                            cell = item.value.replace((this.companyReportSheets[this.sheetIndex].sheet_code + "!"), "");
                                            letter = this.getLetter(cell);
                                            number = this.getNumber(cell);

                                            if (isInsert) {
                                                if (number > (key + 1)) {
                                                    this.companyReportSheets[navigateChild].template[rowIndex].columns[columnIndex].value = this.companyReportSheets[navigateChild].template[rowIndex].columns[columnIndex].value.replace((letter + number), (letter + (number + 1)));
                                                }
                                            }

                                            else {
                                                if (number == (key + 1)) {
                                                    this.companyReportSheets[navigateChild].template[rowIndex].columns[columnIndex].value = this.companyReportSheets[navigateChild].template[rowIndex].columns[columnIndex].value.replace((letter + number), '#REF!');
                                                }

                                                else if (number > (key + 1)) {
                                                    this.companyReportSheets[navigateChild].template[rowIndex].columns[columnIndex].value = this.companyReportSheets[navigateChild].template[rowIndex].columns[columnIndex].value.replace((letter + number), (letter + (number - 1)));
                                                }
                                            }
                                        }
                                    }
                                });
                            });
                            this.setComponents(this.companyReportSheets, navigateChild, true);
                        }

                        catch (err) {
                            console.log(err);
                        }

                        finally {
                            number = null;
                            letter = null;
                            cell = null;
                        }
                    }, 0);
                });
            },
            showCompanyTooltip(company: any) {
                if (company != null && company.name != null) {
                    return company.name;
                }
                return 'Company';
            },
            showDebitCompanies(rowIndex: any) {
                var companies = structuredClone(this.debitCompanies).filter((c: any) => c.isVirtual == false);
                var debitCompanies = [] as any[];

                if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].actualValue.credit != null) {
                    for (var i = 0; i < this.companyReportSheets[this.sheetIndex].template.length; i++) {
                        if (this.companyReportSheets[this.sheetIndex].template[i].columns[0].actualValue != null && this.companyReportSheets[this.sheetIndex].template[i].columns[0].actualValue.credit != null) {
                            if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].actualValue.credit.name == this.companyReportSheets[this.sheetIndex].template[i].columns[0].actualValue.credit.name) {
                                if (this.companyReportSheets[this.sheetIndex].template[i].columns[0].actualValue.debit != null) {
                                    debitCompanies.push(this.companyReportSheets[this.sheetIndex].template[i].columns[0].actualValue.debit.name)
                                }
                            }
                        }
                    }
                }

                debitCompanies.forEach(debitCompany => {
                    var companyIndex = companies.findIndex((c: any) => c.name == debitCompany);
                    if (companyIndex != -1) {
                        companies.splice(companyIndex, 1)
                    }
                });

                return companies;
            },
            showCreditCompanies(rowIndex: any) {
                var companies = structuredClone(this.creditCompanies).filter((c: any) => c.isVirtual == false);
                var creditCompanies = [] as any[];

                if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].actualValue.debit != null) {
                    for (var j = 0; j < this.companyReportSheets[this.sheetIndex].template.length; j++) {
                        if (this.companyReportSheets[this.sheetIndex].template[j].columns[0].actualValue != null && this.companyReportSheets[this.sheetIndex].template[j].columns[0].actualValue.debit != null) {
                            if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].actualValue.debit.name == this.companyReportSheets[this.sheetIndex].template[j].columns[0].actualValue.debit.name) {
                                if (this.companyReportSheets[this.sheetIndex].template[j].columns[0].actualValue.credit != null) {
                                    creditCompanies.push(this.companyReportSheets[this.sheetIndex].template[j].columns[0].actualValue.credit.name)
                                }
                            }
                        }
                    }
                }
                
                creditCompanies.forEach(creditCompany => {
                    var companyIndex = companies.findIndex((c: any) => c.name == creditCompany);
                    if (companyIndex != -1) {
                        companies.splice(companyIndex, 1)
                    }
                });
                
                return companies;
            },
            // checkDebitCompanyExist(rowIndex: any, company: any) {
            //     if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].actualValue.credit != null) {
            //         for (var i = 0; i < this.companyReportSheets[this.sheetIndex].template.length; i++) {
            //             if (this.companyReportSheets[this.sheetIndex].template[i].columns[0].actualValue != null && this.companyReportSheets[this.sheetIndex].template[i].columns[0].actualValue.credit != null) {
            //                 if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].actualValue.credit == this.companyReportSheets[this.sheetIndex].template[i].columns[0].actualValue.credit) {
            //                     if (i != rowIndex && this.companyReportSheets[this.sheetIndex].template[i].columns[0].actualValue.debit != null && this.companyReportSheets[this.sheetIndex].template[i].columns[0].actualValue.debit.identifier == company.option.identifier) {
            //                         return true;
            //                     }

            //                     if (this.companyReportSheets[this.sheetIndex].template[i].columns[0].actualValue.credit.identifier == company.option.identifier) {
            //                         return true;
            //                     }
            //                 }
            //             }
            //         }
            //     }
            //     return false;
            // },
            // checkCreditCompanyExist(rowIndex: any, company: any) {
            //     if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].actualValue.debit != null) {
            //         for (var j = 0; j < this.companyReportSheets[this.sheetIndex].template.length; j++) {
            //             if (this.companyReportSheets[this.sheetIndex].template[j].columns[0].actualValue != null && this.companyReportSheets[this.sheetIndex].template[j].columns[0].actualValue.debit != null) {
            //                 if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].actualValue.debit == this.companyReportSheets[this.sheetIndex].template[j].columns[0].actualValue.debit) {
            //                     if (j != rowIndex && this.companyReportSheets[this.sheetIndex].template[j].columns[0].actualValue.credit != null && this.companyReportSheets[this.sheetIndex].template[j].columns[0].actualValue.credit.identifier == company.option.identifier) {
            //                         return true;
            //                     }

            //                     if (this.companyReportSheets[this.sheetIndex].template[j].columns[0].actualValue.debit.identifier == company.option.identifier) {
            //                         return true;
            //                     }
            //                 }
            //             }
            //         }
            //     }
            //     return false;
            // },
            isDisableCompany(rowIndex: any) {
                if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].component == 'COMPANY' && this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].actualValue.debit != null && this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].actualValue.credit != null) {
                    for (var i = 1; i < this.companyReportSheets[this.sheetIndex].template[rowIndex].columns.length; i++) {
                        if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[i].component == 'NUMBER') {
                            if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[i].actualValue != null && this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[i].actualValue != 0) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            },
            isDisableCompanyInputRow(rowIndex: any) {
                if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].component == 'COMPANY' && (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].actualValue.debit == null || this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].actualValue.credit == null)) {
                    return true;
                }
                return false;
            },
            checkNonCompanyExist(rowIndex: any, dropdown: any, component: any) {
                do {
                    rowIndex--;
                    if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].component == component) {
                        if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].actualValue != null) {
                            if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].actualValue.name == dropdown.option.name) {
                                return true;
                            }
                        }
                    }
                } while (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].component == component);

                do {
                    rowIndex++;
                    if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].component == component) {
                        if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].actualValue != null) {
                            if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].actualValue.name == dropdown.option.name) {
                                return true;
                            }
                        }
                    }
                } while (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].component == component);

                return false;
            },
            isDisableNonCompany(rowIndex: any, component: any, direction: any) {
                if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].component == component && this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].actualValue != null) {
                    for (var i = 1; i < this.companyReportSheets[this.sheetIndex].template[rowIndex].columns.length; i++) {
                        if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[i].component == 'NUMBER' || this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[i].component == 'NAVIGATE' || this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[i].component == 'FORMULA') {
                            if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[i].actualValue != null && this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[i].actualValue != 0) {
                                return true;
                            }
                        }
                    }
                }

                do {
                    rowIndex = direction == 'up' ? rowIndex - 1 : rowIndex + 1;

                    if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].component == component) {
                        if (direction == 'up' && this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].actualValue == null) {
                            return true;
                        }

                        else if (direction == 'down' && this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].actualValue != null) {
                            return true;
                        }
                    }

                } while (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].component == component);

                return false;
            },
            isDisableNonCompanyInputRow(rowIndex: any) {
                if ((this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].component == 'COUNTRY' || this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].component == 'CURRENCY') && (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[0].actualValue == null || this.companyReportSheets[this.sheetIndex].template[rowIndex + 1].columns[0].actualValue != null)) {
                    return true;
                }
                return false;
            },
            inputFocus(rowIndex: any, columnIndex: any) {
                if (rowIndex != 0 || columnIndex != 0) {
                    this.focusArea.rowIndex = rowIndex;
                    this.focusArea.columnIndex = columnIndex;

                    setTimeout(() => {
                        this.setComponentHeader();
                    }, 0);
                }

                else {
                    this.componentHeader = null as any;
                }
            },
            clearFocusInput() {
                if (this.focusArea.rowIndex != 0 && this.focusArea.columnIndex != 0) {
                    if (this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[this.focusArea.columnIndex].component == 'NUMBER') {
                        this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[this.focusArea.columnIndex].actualValue = null;
                        this.changeNumberValue(this.focusArea.rowIndex, this.focusArea.columnIndex, true);
                    }

                    else {
                        this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[this.focusArea.columnIndex].actualValue = null;
                        this.changeTextValue(this.focusArea.rowIndex, this.focusArea.columnIndex, true);
                    }
                }
            },
            setKeyPressDetection() {
                window.addEventListener('keydown', this.detectKeyPress);
            },
            removeKeyPressDetection() {
                window.removeEventListener('keydown', this.detectKeyPress);
            },
            detectKeyPress(event: any) {
                if (Date.now() - store.getters.getKeyPressedTime <= 1000) {
                    return;
                }

                var inputElements = null;
                var inputField = null;

                switch (event.key) {
                    case 'F1': {
                        event.preventDefault();
                        document.getElementById("btnShortcutTips")?.dispatchEvent(new Event('mouseover'));
                        break;
                    }
                    case 'F2': {
                        event.preventDefault();
                        this.zoomOut();
                        break;
                    }
                    case 'F3': {
                        event.preventDefault();
                        this.zoomIn();
                        break;
                    }
                    case 'F4': {
                        event.preventDefault();
                        this.resetZoom();
                        break;
                    }
                    case 'F5': {
                        if (!this.isRoot) {
                            event.preventDefault();
                        }
                        break;
                    }
                    case 'F6': {
                        event.preventDefault();
                        (this.$refs.sheetDialogDropdown as any).show(true);
                        break;
                    }
                    case 'F7': {
                        event.preventDefault();
                        if (this.focusArea.rowIndex != 0 && this.focusArea.columnIndex != null) {
                            inputElements = document.getElementsByClassName(this.sheetIndex + "_" + this.getHeader(this.focusArea.rowIndex, this.focusArea.columnIndex));
                            if (inputElements != null) {
                                inputField = inputElements[0]?.querySelector('div')?.querySelector("div")?.querySelector('div')?.querySelector('span')?.querySelector('input');
                                inputField?.blur();
                                inputField = null;
                            }
                            inputElements = null;
                        }
                        setTimeout(() => {
                            (this.$refs.navigatePrev as any).$el.click();
                        }, 0);
                        break;
                    }
                    case 'F8': {
                        event.preventDefault();
                        if (this.focusArea.rowIndex != 0 && this.focusArea.columnIndex != null) {
                            inputElements = document.getElementsByClassName(this.sheetIndex + "_" + this.getHeader(this.focusArea.rowIndex, this.focusArea.columnIndex));
                            if (inputElements != null) {
                                inputField = inputElements[0]?.querySelector('div')?.querySelector("div")?.querySelector('div')?.querySelector('span')?.querySelector('input');
                                inputField?.blur();
                                inputField = null;
                            }
                            inputElements = null;
                        }
                        setTimeout(() => {
                            (this.$refs.navigateNext as any).$el.click();
                        }, 0);
                        break;
                    }
                    case 'F9': {
                        event.preventDefault();
                        if (this.focusArea.rowIndex != 0 && this.focusArea.columnIndex != 0) {
                            const cell = this.companyReportSheets[this.sheetIndex].template[this.focusArea.rowIndex].columns[this.focusArea.columnIndex];
                            if (cell.component == 'NAVIGATE' || cell.component == 'FORMULA' && cell.value != null && cell.value.includes('!')) {
                                this.navigateCellComponent(this.focusArea.rowIndex, this.focusArea.columnIndex);
                            }
                        }
                        break;
                    }
                    case 'F10': {
                        event.preventDefault();
                        if (this.focusArea.rowIndex != 0 && this.focusArea.columnIndex != null) {
                            inputElements = document.getElementsByClassName(this.sheetIndex + "_" + this.getHeader(this.focusArea.rowIndex, this.focusArea.columnIndex));
                            if (inputElements != null) {
                                inputField = inputElements[0]?.querySelector('div')?.querySelector("div")?.querySelector('div')?.querySelector('span')?.querySelector('input');
                                inputField?.blur();
                                inputField = null;
                            }
                            inputElements = null;
                        }
                        setTimeout(() => {
                            this.onNavigateBack();
                        }, 0);
                        break;
                    }
                    case 'Escape': {
                        event.preventDefault();
                        this.clearFocusInput();
                        break;
                    }
                }
            },
            toggleTips(event: any) {
                if (this.$refs.shortcutTips != null) {
                    (this.$refs.shortcutTips as any).toggle(event);
                }
            },
            onArrowKeysPress(event: any, rowIndex: any, columnIndex: any) {
                if (event.keyCode >= 37 && event.keyCode <= 40) {
                    event.preventDefault();

                    if (event.target.value == '0') {
                        event.target.value = '';
                    }

                    var nextIndex = {row: rowIndex, column: columnIndex};
                    if (event.keyCode == 37) {
                        nextIndex = {row: nextIndex.row, column: nextIndex.column - 1};
                        while (nextIndex.column > 0 && !(this.isFocusable(nextIndex))) {
                            nextIndex.column -= 1;
                        }
                    }

                    else if (event.keyCode == 38) {
                        nextIndex = {row: nextIndex.row - 1, column: nextIndex.column};
                        while (nextIndex.row > 0 && !(this.isFocusable(nextIndex))) {
                            nextIndex.row -= 1;
                        }
                    }

                    else if (event.keyCode == 39) {
                        nextIndex = {row: nextIndex.row, column: nextIndex.column + 1};
                        while (nextIndex.column < this.companyReportSheets[this.sheetIndex].template[nextIndex.row].columns.length && !(this.isFocusable(nextIndex))) {
                            nextIndex.column += 1;
                        }
                    }

                    else if (event.keyCode == 40) {
                        nextIndex = {row: nextIndex.row + 1, column: nextIndex.column};
                        while (nextIndex.row < this.companyReportSheets[this.sheetIndex].template.length && !(this.isFocusable(nextIndex))) {
                            nextIndex.row += 1;
                        }
                    }

                    this.onFocusChange(nextIndex.row, nextIndex.column);
                }

                else if (['FORMULA'].includes(this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[columnIndex].component)) {
                    event.preventDefault();
                }
            },
            isFocusable(nextIndex: any) {
                if (['NUMBER', 'NAVIGATE', 'TEXT', 'LONGTEXT', 'VALUE'].includes(this.companyReportSheets[this.sheetIndex].template[nextIndex.row].columns[nextIndex.column].component)) {
                    return true;
                }

                else if (['FORMULA'].includes(this.companyReportSheets[this.sheetIndex].template[nextIndex.row].columns[nextIndex.column].component)) {
                    return !this.companyReportSheets[this.sheetIndex].template[nextIndex.row].columns[nextIndex.column].value.startsWith('=IF(');
                }

                return false;
            },
            onFocusChange(rowIndex: any, columnIndex: any) {
                if (rowIndex != null && columnIndex != null) {
                    var inputElements = null as any;
                    var inputField = null as any;

                    try {
                        if (this.companyReportSheets[this.sheetIndex] != null) {
                            inputElements = document.getElementsByClassName(this.sheetIndex + "_" + this.getHeader(rowIndex, columnIndex));
                            if (inputElements != null) {
                                inputField = inputElements[0]?.querySelector('div')?.querySelector("div")?.querySelector('div')?.querySelector('span')?.querySelector('input');
                                if (this.companyReportSheets[this.sheetIndex].template[rowIndex] != null && this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[columnIndex] != null) {
                                    if (['TEXT', 'LONGTEXT', 'VALUE', 'HEADERTEXT'].includes(this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[columnIndex].component)) {
                                        inputField = inputElements[0]?.querySelector('div')?.querySelector("div")?.querySelector('div')?.querySelector('input');
                                    }

                                    else if (['FORMULA'].includes(this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[columnIndex].component)) {
                                        if (this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[columnIndex].actualValue != null && isNaN(this.companyReportSheets[this.sheetIndex].template[rowIndex].columns[columnIndex].actualValue)) {
                                            inputField = inputElements[0]?.querySelector('div')?.querySelector("div")?.querySelector('div')?.querySelector('input');
                                        }
                                    }

                                    inputField?.focus();
                                    inputField?.setSelectionRange(inputField.value.length, inputField.value.length);
                                }
                            }
                        }
                    }

                    finally {
                        inputField = null;
                        inputElements = null;
                    }
                }
            },
            highlightInput(event: any){
                const target = event.target;
                setTimeout(() => {
                    if (document.activeElement === target) {
                        target.select?.();
                    }
                }, 0);
            }
        },
        setup() {

            const shortcutMenu = ref();
            const toggleShortcutMenu = (event: any) => {
                shortcutMenu.value.toggle(event);
            };
            
            return {shortcutMenu, toggleShortcutMenu, v$: useVuelidate()};
        },
        validations() {
            return {
                commentDialog: {
                    comment: {
                        required
                    }
                }
            };
        },
    });
</script>
